<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row v-if="pagePrincipal" align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <span class="login-title">
                <img :src="empresa.logoUrl" width="100%" style="max-width: 180px" />
              </span>
              <v-card-actions style="padding: 0px; margin-top: 0px">
                <v-container fluid grid-list-md style="padding: 0px">
                  <v-layout row wrap justify-center v-if="eventos.length >= 1">
                    <v-container>
                      <v-row dense>
                        <v-col cols="12" sm="12" md="4" lg="4" v-for="evento in eventos" :key="evento.id">
                          <v-card outlined>
                            <v-alert v-if="evento.exibePorcentagem"
                              style="margin: 0px; text-align: center; border-radius: 0px;" color="red" dark dense>
                              <b v-if="evento.exigePagamento">
                                {{ ((evento.quantidadeInscricoes * 100) / evento.vagas).toFixed(0) }}% VENDIDOS
                              </b>
                              <b v-else>
                                {{ ((evento.quantidadeInscricoes * 100) / evento.vagas).toFixed(0) }}% VENDIDOS
                              </b>
                            </v-alert> 
                            <v-img class="mx-auto" height="auto" width="100%" :src="evento.urlCapa"></v-img>
                            <v-card-title class="mx-auto no-break">{{ evento.nome }}</v-card-title>
                            <v-card-text>
                              <div>
                                <v-icon>mdi-calendar</v-icon>
                                {{ formatDateHora(evento.inicio) }}
                              </div>
                              <div style="margin-top: 5px" v-if="evento.local">
                                <v-icon>mdi-map-marker</v-icon>
                                {{ evento.local }}
                                <span v-if="evento.localizacao">
                                  <a :href="evento.localizacao" target="_blank">Ver no mapa</a>
                                </span>
                              </div>
                              <div style="margin-top: 5px"
                                v-if="evento.exigePagamento && !evento.valorPix && !evento.valorCartao">
                                <v-icon>mdi-ticket-confirmation</v-icon>
                                Setores disponíveis:
                                <ul style="margin: 0px; padding-left: 5px" v-for="valor in evento.setores"
                                  :key="valor.nome">
                                  <p :style="'margin: 0px; color: ' + valor.cor">
                                    <v-icon :color="valor.cor" size="12" style="padding-bottom: 2px">mdi-circle</v-icon>
                                    {{ valor.nome }}: R$ {{ valor.valor }}
                                  </p>
                                </ul>
                              </div>
                              <div style="margin-top: 5px"
                                v-if="!evento.exigePagamento && !evento.valorPix && !evento.valorCartao">
                                <v-icon>mdi-ticket-confirmation</v-icon>

                                <ul style="margin: 0px" v-for="valor in evento.setores" :key="valor.nome">
                                  <li>
                                    {{ valor.nome }}: R$ {{ valor.valor }}
                                  </li>
                                </ul>
                              </div>
                              <div style="margin-top: 5px" v-if="evento.valorPix || evento.valorCartao">
                                <ul style="margin: 0px; padding-left: 5px">
                                  <p style="margin: 0px" v-if="evento.valorPix">
                                    <b>Pix:</b> R$ {{ evento.valorPix }}
                                  </p>
                                  <p style="margin: 0px" v-if="evento.valorCartao">
                                    <b>Cartão:</b> em até {{ evento.quantidadeParcelas }}x de {{ calculaParcelas(evento)
                                    }}
                                  </p>
                                </ul>
                              </div>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn dark depressed color="#6d3313" @click="realizarInscricaoGrupo(evento)"
                                :disabled="evento.quantidadeInscricoes >= evento.vagas">Comprar
                                agora</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-flex xs12 sm12 lg12 style="text-align: center; padding: 0px 10px 0px 10px; margin-bottom: 17px;">
                      <v-card flat>
                        <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="300px" />
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="empresa.telefone">
                      <v-btn color="#1976D2" dark depressed block large tile
                        :href="'https://wa.me/55' + empresa.telefone + '?text=Olá,%20pode%20me%20ajudar%20com%20o%20Aniversário%20Déboras?%20'"
                        target="_blank">
                        <v-icon left>chat</v-icon>
                        Dúvidas? Fale Conosco!
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="padding: 0px 10px 0px 10px; margin-bottom: 17px;">
                      <div>
                        <p class="font-bold black-color" style="text-align: center; font-size: 1.5rem">
                          Descrição do evento
                        </p>
                        <p class="font-regular black-color">
                          Organizado pela Irmã Liliane França na Assembleia de Deus Libertas.
                          Contamos sempre com muitas convidadas cheias de Deus, trazendo muita palavra, louvor e adoração. 
                          Venha você também ser edificada.
                        </p>
                        <p class="font-regular black-color">
                          Contamos sempre com muitas convidadas cheias de Deus, trazendo muita palavra, louvor e adoração. Venha você também ser edificada.
                        </p>
                        <p class="font-regular black-color" style="
                                font-size: 1.5rem;
                                background-color: #eeff41;
                                text-align: center;
                              ">
                          Não fique de fora!
                        </p>
                        <p><b>Importante:</b> A camisa lhe dará acesso aos três dias de evento.</p>
                        <ul>
                          <li><b>Proibida a entrada de crianças;</b></li>
                          <li><b>Estacionamento gratuito;</b></li>
                          <li><b>Teremos cantina nos três dias de evento;</b></li>
                          <li><b>Meia entrada não se aplica a esse evento;</b></li>
                          <li><b>Regra sobre o cancelamento: </b></li>
                          <p>Prazo máximo de solicitação de cancelamento e reembolso: 7 dias após a compra e até 48
                            antes do evento.</p>
                        </ul>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center v-else-if="eventos.length == 0">
                    <v-flex xs12 sm12 lg12>
                      <v-alert type="info">Nenhum evento em cartaz</v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- pagina pagamento -->
        <v-row v-if="pagePagamento" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="indicacao">
                      <v-alert type="info">
                        Você está usando o link do divulgador
                        {{ this.divulgador.nome }}
                      </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Preencha os dados do cartão de crédito:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="pagamento.nomeTitular" label="NOME IMPRESSO NO CARTÃO" single-line
                        outlined color="#00695C" dense hide-details required v-validate="'required'"
                        :error-messages="errors.collect('nomeCartao')" data-vv-name="nomeCartao"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light v-model="pagamento.cartaoNumero" v-mask="maskCartao" label="NÚMERO DO CARTÃO"
                        single-line outlined color="#00695C" dense hide-details required v-validate="'required'"
                        :error-messages="errors.collect('numCartao')" data-vv-name="numCartao"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="pagamento.cpfTitular" v-mask="'###.###.###-##'"
                        v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')"
                        data-vv-name="cpftitular" label="CPF DO TITULAR" single-line outlined color="#00695C" dense
                        hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-text-field light v-mask="'###'" v-model="pagamento.cvv" label="CVV" single-line outlined
                        color="#00695C" dense hide-details type="password" required v-validate="'required'"
                        :error-messages="errors.collect('codCartao')" data-vv-name="codCartao"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-select outlined dense v-model="pagamento.mesVencimento" :items="mesesVencimento" hide-details
                        item-text="titulo" item-value="id" color="#00695C" label="MÊS VENCIMENTO"
                        v-validate="'required'" :error-messages="errors.collect('expiraCartaoMes')"
                        data-vv-name="expiraCartaoMes"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-select outlined dense v-model="pagamento.anoVencimento" :items="anosVencimento" hide-details
                        item-text="titulo" item-value="id" color="#00695C" label="ANO VENCIMENTO"
                        v-validate="'required'" :error-messages="errors.collect('expiraCartaoAno')"
                        data-vv-name="expiraCartaoAno"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-select outlined dense v-model="pagamento.bandeira" :items="bandeiras" hide-details
                        item-text="text" item-value="value" color="#00695C" label="BANDEIRA" v-validate="'required'"
                        :error-messages="errors.collect('bandeira')" data-vv-name="bandeira"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="pagamento.valorEscolhido" :items="parcelas" hide-details
                        color="#00695C" label="PARCELAS" v-validate="'required'"
                        :error-messages="errors.collect('parcelas')" data-vv-name="parcelas"
                        @input="carregaQtdParcelas"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Preencha as informações de endereço e e-mail
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-mask="'#####-###'" v-model="pagamento.cep" label="CEP" single-line outlined
                        type="tel" color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="pagamento.numero" label="NÚMERO DO ENDEREÇO" single-line outlined
                        type="tel" color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-text-field light v-model="pagamento.email" label="E-MAIL" single-line outlined color="#00695C"
                        dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-left>
                    <v-flex xs10 sm10 lg12 style="margin-top: 20px">
                      <h2>Detalhes da Compra:</h2>
                    </v-flex>
                    <v-flex xs10 sm10 lg12>
                      <h4 style="color: orange">
                        {{ eventoSelecionado.nome }}
                      </h4>
                    </v-flex>
                    <v-flex xs10 sm10 lg12>
                      <h2 style="color: orange" v-if="!textoParcela">
                        Total:
                        {{
                          valorTotalCompra.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </h2>
                      <h2 style="color: orange" v-else>{{ textoParcela }}</h2>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px" large
                        @click="pagamentoCartao">Realizar Pagamento</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-btn dark depressed block color="#E53935" style="border-radius: 7px" large
                        @click="cancelarPagamento">Cancelar</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img src="../../assets/site-seguro-blindado.png" width="100%" style="max-width: 280px" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- pagina pagamento -->

        <!-- pagina consulta -->
        <v-row v-if="pageConsulta" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Selecione o evento que você deseja consultar:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id"
                        color="#00695C"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Preencha os dados abaixo para consultar a inscrição:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin: 0 auto">
                      <v-text-field light label="CPF DO RESPONSÁVEL FINANCEIRO" color="#00695C" outlined
                        v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'"
                        :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel"
                        v-model="cpf"></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="email" label="EMAIL" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px" large
                        @click="consultarInscricao(cpf)">Consultar Inscrição</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- fim pagina consulta -->

        <!-- PÁGINA INSCRIÇÃO -->
        <v-row v-if="paginaInscricaoGrupo" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="!bloqueiaVoltar">
                      <v-btn outlined @click="retornaPaginaPrincipal">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center" v-if="eventoSelecionado.urlMapa">
                      <!-- <h3 style="margin: 0px">Mapa do evento</h3> -->
                      <img :src="eventoSelecionado.urlMapa" alt="MapaEvento" width="100%"
                        style="max-width: 500px; margin-top: 10px" />
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="!quantidade.length == 1">
                      <br />
                      <p style="margin-bottom: 0px">Quantidade:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg1 v-if="!quantidade.length == 1">
                      <v-select outlined dense hide-details v-model="qtdCompra" :items="quantidade"
                        @input="verificaCapacidade()"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin-top: 20px" v-if="!quantidade.length == 1">
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container fluid grid-list-md v-for="index in qtdCompra" :key="index">
                  <v-layout row wrap justify-left style="margin-bottom: 20px">
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px" v-if="qtdCompra != 1">
                        Dados do {{ index }}º participante:
                      </p>
                      <p style="margin-bottom: 0px" v-else>
                        Dados do participante:
                      </p>
                    </v-flex>

                    <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.tipoDocumento == 'AMBOS'">
                      <v-radio-group v-model="inscricao[index - 1].tipoDocumento" row @change="limpaSetor(index - 1)">
                        <v-radio label="CPF" value="CPF"></v-radio>
                        <v-radio label="CNPJ" value="CNPJ"></v-radio>
                      </v-radio-group>
                      <v-alert v-if="eventoSelecionado.desconto && inscricao[index - 1].tipoDocumento == 'CNPJ'" dark
                        type="success">
                        Desconto de R$ {{ eventoSelecionado.desconto }} aplicado!
                      </v-alert>
                    </v-flex>

                    <v-flex xs12 sm12 lg4
                      v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF'">
                      <v-text-field label="CPF DO RESPONSÁVEL FINANCEIRO" v-model="inscricao[index - 1].cpf" light
                        color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required type="tel"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CPF')"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4
                      v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                      <v-text-field label="CNPJ" v-model="inscricao[index - 1].cpf" light color="#00695C" outlined
                        v-mask="'##.###.###/####-##'" dense hide-details required type="tel"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CNPJ')"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg4>
                      <v-text-field label="WHATSAPP COM DDD" v-model="inscricao[index - 1].telefone" light
                        color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense
                        required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select label="QUANTIDADE DE SENHAS EXTRAS" hide-details
                        v-model="inscricao[index - 1].qtdSenhasExtra" outlined dense :items="numbers"
                        color="#00695C"></v-select>
                    </v-flex>

                    <v-flex xs12 sm12 lg12>
                      <v-divider v-if="index != qtdCompra" style="margin-top: 40px"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12>
                    <v-checkbox v-model="aceiteLgpd" style="margin-top: 10px">
                      <template v-slot:label>
                        <div>
                          Concordo com as <a target="_blank"
                            href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_6acd8479401b41da80bfe3bbf2a0d37d.pdf"
                            @click.stop>políticas de privacidade e tratamento de dados pessoais</a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px" v-if="eventoSelecionado.urlImgObs">
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <img :src="eventoSelecionado.urlImgObs" width="100%" style="max-width: 300px" />
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h2>Detalhes da Compra:</h2>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h3 style="color: orange">{{ eventoSelecionado.nome }}</h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="!eventoSelecionado.valorPix && !eventoSelecionado.valorCartao">
                    <h3 style="color: orange">
                      Total: {{ valorTotalCompra.toLocaleString("pt-BR", { style: "currency", currency: "BRL", }) }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.valorPix || eventoSelecionado.valorCartao">
                    <h3 style="color: orange" v-if="eventoSelecionado.valorPix">
                      Pix: {{ (parseFloat(this.eventoSelecionado.valorPix.replace(",", ".")) *
                        this.inscricao[0].qtdSenhasExtra).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                      }}
                    </h3>
                    <h3 style="color: orange" v-if="eventoSelecionado.valorCartao">
                      Cartão: em até {{ eventoSelecionado.quantidadeParcelas }}x de {{
                        calculaParcelas(eventoSelecionado,
                          inscricao[0].qtdSenhasExtra) }}
                    </h3>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.valorCartao">
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="prosseguirPagamento('CARTÃO')">
                        <img style="margin-right: 5px" src="../../assets/credit-card.png" width="25px" />
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamentoBoleto">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.valorPix">
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="prosseguirPagamento('PIX')">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="20px" />
                        Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="250px" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO -->

        <!-- PÁGINA INSCRIÇÃO VAGAS -->
        <v-row v-if="paginaInscricaoVagas" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="!bloqueiaVoltar">
                      <v-btn outlined @click="retornaPaginaPrincipal">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="!quantidade.length == 1">
                      <br />
                      <p style="margin-bottom: 0px">Quantidade:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg1 v-if="!quantidade.length == 1">
                      <v-select outlined dense hide-details v-model="qtdCompra" :items="quantidade"
                        @input="verificaCapacidade()"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin-top: 20px" v-if="!quantidade.length == 1">
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container fluid grid-list-md v-for="index in qtdCompra" :key="index">
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px" v-if="qtdCompra != 1">
                        Dados do {{ index }}º participante:
                      </p>
                      <p style="margin-bottom: 0px" v-else>
                        Dados do participante:
                      </p>
                    </v-flex>

                    <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.tipoDocumento == 'AMBOS'">
                      <v-radio-group v-model="inscricao[index - 1].tipoDocumento" row @change="limpaSetor(index - 1)">
                        <v-radio label="CPF" value="CPF"></v-radio>
                        <v-radio label="CNPJ" value="CNPJ"></v-radio>
                      </v-radio-group>
                      <v-alert v-if="eventoSelecionado.desconto && inscricao[index - 1].tipoDocumento == 'CNPJ'" dark
                        type="success"> Desconto de R$ {{ eventoSelecionado.desconto }} aplicado!</v-alert>
                    </v-flex>

                    <v-flex xs12 sm12 lg4
                      v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF'">
                      <v-text-field label="CPF DO RESPONSÁVEL FINANCEIRO" v-model="inscricao[index - 1].cpf" light
                        color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required type="tel"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CPF')"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4
                      v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                      <v-text-field label="CNPJ" v-model="inscricao[index - 1].cpf" light color="#00695C" outlined
                        v-mask="'##.###.###/####-##'" dense hide-details required type="tel"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CNPJ')"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg8
                      v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF'">
                      <v-text-field label="NOME COMPLETO" v-model="inscricao[index - 1].nome" light single-line outlined
                        color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8
                      v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                      <v-text-field label="RAZÃO SOCIAL" v-model="inscricao[index - 1].nome" light single-line outlined
                        color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg4>
                      <v-text-field label="WHATSAPP COM DDD" v-model="inscricao[index - 1].telefone" light
                        color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense
                        required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-select label="TAMANHO DA CAMISA" v-model="inscricao[index - 1].tamanhoCamisa" light
                        color="#00695C" outlined hide-details :items="tamanhos" dense required
                        item-text="tamanho" item-value="tamanho" item-disabled="desativado"
                        @input="verificaCamisa(inscricao[index - 1].tamanhoCamisa, 'inscricao', index - 1)"></v-select>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg8>
                      <v-text-field
                        label="FILHO"
                        :value="formatarLista(inscricao[index - 1].filho)"
                        light
                        color="#00695C"
                        outlined
                        hide-details
                        readonly
                        dense
                      ></v-text-field>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg12 v-if="index != qtdCompra">
                      <v-divider v-if="index != qtdCompra" style="margin-top: 40px"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-flex xs12 sm12 lg12 style="text-align: center" v-if="exibeMapa">
                  <v-flex xs10 sm10 lg6 style="text-align: left; margin: 0px auto">
                    <table style="width: 100%">
                      <tr>
                        <td>
                          <p style="margin: 0px; font-size: 11px"><v-icon small color="#22b42c">mdi-square</v-icon>Livre
                          </p>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#ff5050">mdi-square</v-icon>Ocupado</p>
                        </td>
                        <td>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#2024b6">mdi-square</v-icon>Selecionado
                            por você</p>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#767171">mdi-square</v-icon>Selecionado
                            por outra pessoa</p>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                  <div ref="matrixContainer" :style="backgroundStyle" style="overflow: hidden; display: inline-block;">
                    <table ref="matrixTable" :key="x">
                      <tr v-for="(row, rowIndex) in matrix" :key="rowIndex">
                        <td v-for="(cell, colIndex) in row" :key="colIndex"
                          @click="cell.status != 'OCUPADO' || !cell.bloqueado || cell.active ? cellClicked(rowIndex, colIndex) : ''"
                          :data-cell-number="cell.localizacao" style="position: relative;">
                          <!--                         <span v-if="cell.tipo == 'Mesa'"> -->
                          <img style="cursor: pointer;" v-if="cell.status == 'LIVRE' && cell.active"
                            src="../../assets/cadeira_verde.png" width="7.5px" />
                          <img style="cursor: pointer"
                            v-if="cell.status == 'SELECIONADO' && !cell.bloqueado && cell.active"
                            src="../../assets/cadeira_azul.png" width="7.5px" />
                          <img style="cursor: pointer"
                            v-if="cell.status == 'SELECIONADO' && cell.bloqueado && cell.active"
                            src="../../assets/cadeira_cinza.png" width="7.5px" />
                          <img style="cursor: pointer" v-if="cell.status == 'OCUPADO' && cell.active"
                            src="../../assets/cadeira_vermelha.png" width="7.5px" />
                          <p
                            style="font-size: 3px; margin: 0px; color: white; cursor: pointer; position: absolute; top: 53%; left: 60%; transform: translate(-50%, -50%); z-index: 1">
                            {{ cell.vaga }}</p>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <p style="background-color: black; color: white; font-weight: bold; padding: 2px; line-height: 1.0rem"
                    v-if="inscricao[0].vagas && inscricao[0].vagas.length > 0">
                    ATENÇÃO: Ao selecionar uma cadeira, você terá 15 minutos para realizar o pagamento. Após esse prazo,
                    a
                    vaga
                    será liberada para outra pessoa.
                  </p>
                </v-flex>

                <span v-if="inscricoesExtras.length > 0">
                  <v-container fluid grid-list-md v-for="index in inscricoesExtras.length" :key="index">
                    <v-layout row wrap justify-left>
                      <v-flex xs12 sm12 lg12>
                        <p style="margin-bottom: 0px">
                          Dados do {{ index + 1 }}º participante para a cadeira {{ inscricoesExtras[index - 1].vaga }}:
                        </p>
                      </v-flex>

                      <v-flex xs12 sm12 lg6>
                        <v-text-field
                          label="NOME COMPLETO"
                          v-model="inscricoesExtras[index - 1].nome"
                          light
                          single-line
                          outlined
                          color="#00695C"
                          dense
                          hide-details
                          required
                        ></v-text-field>
                      </v-flex>
                      
                      <v-flex xs12 sm12 lg6>
                        <v-select
                          label="TAMANHO DA CAMISA"
                          v-model="inscricoesExtras[index - 1].tamanhoCamisa"
                          light
                          color="#00695C"
                          outlined
                          hide-details
                          :items="tamanhos"
                          dense
                          required
                          item-text="tamanho"
                          item-value="tamanho"
                          item-disabled="desativado"
                          @input="verificaCamisa(inscricoesExtras[index - 1].tamanhoCamisa, 'inscricoesExtras', index - 1)">
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </span>

                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12>
                    <v-checkbox v-model="aceiteLgpd" style="margin-top: 10px">
                      <template v-slot:label>
                        <div>
                          Concordo com as
                          <a target="_blank"
                            href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_6acd8479401b41da80bfe3bbf2a0d37d.pdf"
                            @click.stop>políticas de privacidade e tratamento de dados
                            pessoais</a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px" v-if="eventoSelecionado.urlImgObs">
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <img :src="eventoSelecionado.urlImgObs" width="100%" style="max-width: 300px" />
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h2>Detalhes da Compra:</h2>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h3 style="color: orange">{{ eventoSelecionado.nome }}</h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="inscricao[0].vagas && inscricao[0].vagas.length > 0">
                    <h3 style="color: orange">
                      Cadeiras selecionadas: {{ vagasSelecionadas }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="!eventoSelecionado.valorPix && !eventoSelecionado.valorCartao">
                    <h3 style="color: orange">
                      Total: {{ valorTotalCompra.toLocaleString("pt-BR", { style: "currency", currency: "BRL", }) }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.valorPix || eventoSelecionado.valorCartao">
                    <h3 style="color: orange"
                      v-if="eventoSelecionado.valorPix && inscricao[0].vagas && inscricao[0].vagas.length > 0">
                      Pix: {{ (typeof valorTotalCompra === 'string' ? parseFloat(valorTotalCompra.replace(",", ".")) : valorTotalCompra || calculaValorInscricoes("valorPix")).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) }}
                    </h3>
                    <h3 style="color: orange"
                      v-if="eventoSelecionado.valorCartao && inscricao[0].vagas && inscricao[0].vagas.length > 0">
                      Cartão: em até {{ eventoSelecionado.quantidadeParcelas }}x de {{
                        calculaParcelas(eventoSelecionado,
                          inscricao[0].vagas.length) }}
                    </h3>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="prosseguirPagamento('CARTÃO')">
                        <img style="margin-right: 5px" src="../../assets/credit-card.png" width="25px" />
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamentoBoleto">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="prosseguirPagamento('PIX')">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="20px" />
                        Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="250px" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO VAGAS -->

        <br />
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoAICheckinIntelite.png" width="250px" />
          </a>
        </div>

        <v-dialog v-model="dialogoIngressoIndividual" persistent max-width="600px">
          <v-card style="border-radius: 12px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.1);">
            <div style="background-color: #2979FF; padding: 16px; text-align: center; border-radius: 10px 10px 0 0;">
              <div style="display: flex; align-items: center; justify-content: center;">
                <v-icon color="white" class="mr-2" size="24">mdi-ticket-confirmation</v-icon>
                <span style="color: white; font-weight: 600; font-size: 18px; letter-spacing: 0.5px;">Ingresso Digital</span>
              </div>
            </div>
            <v-card-text style="padding: 24px 20px; background-color: #FFFFFF;">
              <div style="text-align: center; margin-bottom: 16px;">
                <h3 style="margin: 0 0 4px 0; color: #1E3A8A; font-size: 20px; font-weight: 600;">{{ inscricaoLocalizada.nome }}</h3>
              </div>
              
              <div style="display: flex; justify-content: center; margin: 20px 0;">
                <div style="border: 1px solid #E0E7FF; padding: 12px; background-color: #FFFFFF; border-radius: 12px; display: inline-block; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <enhanced-qr-code 
                      :value="inscricaoLocalizada.cod_incricao" 
                      :size="150"
                      :margin="1"
                      :borderWidth="8"
                      borderColor="#FFFFFF"
                      :borderRadius="8"
                    ></enhanced-qr-code>
                    <p style="margin: 8px 0 0 0; font-size: 13px; font-weight: 500; color: #4B5563; text-align: center;">{{ inscricaoLocalizada.cod_incricao }}</p>
                  </div>
                </div>
              </div>
              
              <div v-if="inscricaoLocalizada.vagas" style="margin-top: 20px; background-color: #F8FAFC; border-radius: 10px; padding: 16px; border-left: 4px solid #2979FF;">
                <div style="font-weight: 500; color: #4B5563; font-size: 14px; margin-bottom: 10px; display: flex; align-items: center;">
                  <v-icon style="color: #2979FF;" class="mr-2">mdi-seat</v-icon>
                  Vagas Reservadas
                </div>
                <div style="font-size: 15px; color: #1F2937; font-weight: 500; padding-left: 4px;">
                  {{ formatarSetor(inscricaoLocalizada.vagas) }}
                </div>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div>
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-calendar</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">{{ inscricaoLocalizada.eventoNome }}</div>
                </div>
                
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-map-marker</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">
                    {{ inscricaoLocalizada.eventoLocal }}
                    <span v-if="inscricaoLocalizada.eventoLocalizacao">
                      (<a :href="inscricaoLocalizada.eventoLocalizacao" target="_blank" style="color: #2979FF; font-weight: 500;">Ver no mapa</a>)
                    </span>
                  </div>
                </div>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div style="display: flex; align-items: center; margin: 10px 0; padding: 12px; background-color: #F0F9FF; border-radius: 8px; border-left: 4px solid #2979FF;">
                <v-icon color="#2979FF" class="mr-3" size="22">mdi-check-circle</v-icon>
                <span style="font-weight: 600; color: #1E3A8A;">Pagamento realizado com sucesso!</span>
              </div>
              
              <p style="font-size: 13px; color: #6B7280; margin: 12px 0; text-align: left;">
                Guarde este comprovante para sua referência no dia do evento
              </p>
            </v-card-text>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;" v-if="inscricaoLocalizada.eventoUsaCartaoConsumo">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#4B5563"
                :href="'https://aiconsumer.intelite.com.br?cod=' + inscricaoLocalizada.cod_incricao">
                <v-icon left>mdi-credit-card-outline</v-icon>
                Cartão Consumo
              </v-btn>
            </v-card-actions>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0"
                @click="dialogoIngressoIndividual = false">
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoListaIngresso" persistent max-width="800px">
          <v-card style="border-radius: 12px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.1);">
            <div style="background-color: #2979FF; padding: 16px; text-align: center; border-radius: 10px 10px 0 0;">
              <div style="display: flex; align-items: center; justify-content: center;">
                <v-icon color="white" class="mr-2" size="24">mdi-ticket-confirmation</v-icon>
                <span style="color: white; font-weight: 600; font-size: 18px; letter-spacing: 0.5px;">Ingressos Digitais</span>
              </div>
            </div>

            <v-card-text style="padding: 24px 20px;">
              <div style="text-align: center; margin-bottom: 16px;">
                <h3 style="margin: 0 0 4px 0; color: #1E3A8A; font-size: 20px; font-weight: 600;">{{ eventoSelecionado.nome }}</h3>
                <div style="font-size: 15px; color: #64748B;">{{ eventoSelecionado.local }}</div>
              </div>

              <div v-if="inscricao.length > 0" style="margin-top: 20px; background-color: #F8FAFC; border-radius: 10px; padding: 16px 20px; border-left: 4px solid #2979FF;">
                <div style="font-weight: 500; color: #4B5563; font-size: 14px; margin-bottom: 10px; display: flex; align-items: center;">
                  <v-icon style="color: #2979FF;" class="mr-2">mdi-account-group</v-icon>
                  Lista de Ingressos ({{ inscricao.length }})
                </div>
                
                <v-data-table
                  :headers="headersIngressos"
                  :items="inscricao"
                  class="elevation-0"
                  style="background-color: transparent; border-radius: 8px;"
                  hide-default-footer
                  :items-per-page="-1"
                >
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      small
                      elevation="0"
                      color="#1565C0"
                      style="text-transform: none; border-radius: 6px; font-weight: 500;"
                      @click="visualizarIngressoIndividual(item)"
                    >
                      <v-icon small left>mdi-eye</v-icon>
                      Ver ingresso
                    </v-btn>
                  </template>
                </v-data-table>
              </div>

              <div v-else style="text-align: center; padding: 24px; background-color: #F9FAFB; border-radius: 8px; margin: 16px 0;">
                <v-icon size="48" color="#94A3B8" class="mb-2">mdi-ticket-off</v-icon>
                <p style="color: #64748B; font-size: 16px;">Nenhum ingresso encontrado para esse evento.</p>
                <div style="display: none">
                  <qrcode-vue :value="'exemplo'" :size="1" level="H" bg-color="white"></qrcode-vue>
                </div>
              </div>

              <div style="display: flex; align-items: center; margin: 24px 0 16px 0; padding: 12px; background-color: #F0F9FF; border-radius: 8px; border-left: 4px solid #2979FF;">
                <v-icon color="#2979FF" class="mr-3" size="22">mdi-information</v-icon>
                <span style="font-weight: 500; color: #1E3A8A; font-size: 14px;">Clique em "Ver ingresso" para visualizar os detalhes e o QR Code de cada ingresso.</span>
              </div>
            </v-card-text>

            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0"
                @click="dialogoListaIngresso = false">
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoBoleto" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">{{ msgResultado }}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #ff0000">
                      Fique atento! Após um dia útil, será enviada uma mensagem
                      no WhatsApp do número informado com a confirmação de
                      pagamento e o seu ingresso digital.
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 2px">
                    <v-btn style="border-radius: 7px" dark depressed @click="abreBoleto">Visualizar Boleto</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px" dark depressed block color="#7b4f44" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoEmMaos" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">{{ msgResultado }}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #ff0000">
                      Sua inscrição foi pré-aprovada. Para confirmar, o
                      pagamento deve ser feito em mãos.
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px" dark depressed block color="#7b4f44" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">Solicitação de Cancelamento</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      CPF : {{ inscricao.cpf }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="background-color: #d32f2f; color: white">
                      Confirme a sua solicitação de cancelamento
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px" dark depressed block color="#00695C"
                @click="realizarCancelamento">confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="pagamentoPix" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 4px">
              <span class="texto" style="color: #00695c; font-weight: bold">{{ msgResultado }}</span>
            </v-card-title>

            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" style="padding: 10px">
                    <p class="texto" style="text-align: left; font-weight: bold;">
                      Copie este código para pagar <b style="color: orange">R$ {{(typeof valorTotalCompra === 'string' ? parseFloat(valorTotalCompra.replace(",", ".")) : parseFloat(valorTotalCompra)).toFixed(2).replace(".", ",")}}</b>:
                    </p>
                    <ol style="text-align: left; padding-left: 16px; margin: 0;">
                      <li>Acesse seu app de pagamentos.</li>
                      <li>Escolha pagar via Pix.</li>
                      <li>Cole o seguinte código:</li>
                    </ol>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 1px">
                    <v-card flat class="d-flex justify-center pa-4" color="white">
                      <enhanced-qr-code
                          v-if="exibirQRCode && empresa.gatewayPagamentoPix == 'SICOOB'"
                          :value="qrCode64"
                          :size="200"
                          :margin="1"
                          :borderWidth="8"
                          borderColor="#FFFFFF"
                          :borderRadius="6"
                      ></enhanced-qr-code>
                      <img
                        v-else-if="exibirQRCode"
                        :src="qrCode64"
                        width="100%"
                        style="max-width: 300px; border-radius: 8px;"
                      />
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="12" style="padding: 10px 0px 10px 0px">
                    <v-text-field
                      v-model="chaveCopiaeCola"
                      label="Chave Pix Copia e Cola"
                      id="chavePix"
                      outlined
                      readonly
                      dense
                      disable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      color="#00695C"
                      dark
                      depressed
                      @click="doCopy('chavePix')"
                      style="border-radius: 10px; font-weight: bold;"
                    >
                      Copiar código
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      text
                      color="#00695C"
                      dark
                      @click="exibirQRCode = !exibirQRCode"
                      style="border-radius: 10px; font-size: 14px; "
                    >
                      {{ exibirQRCode ? 'Ocultar QR Code' : 'Exibir QR Code' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoToken" persistent max-width="400px">
          <v-card style="border-radius: 10px">
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <p>
                  <b>Enviamos um token para seu WhatsApp.<br />Por favor,
                    informe-o abaixo para ter acesso ao seu ingresso digital:</b>
                </p>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" style="padding: 1px">
                    <v-text-field light v-mask="'####'" v-model="token" label="TOKEN" type="tel" single-line outlined
                      color="#00695C" dense hide-details required></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-container fluid grid-list-md>
                <v-spacer></v-spacer>
                <v-btn style="border-radius: 7px" dark block depressed color="#00695C"
                  @click="confirmaToken">Confirmar</v-btn>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoInformacoesGrupo" persistent max-width="600px">
          <v-card style="border-radius: 12px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.1);">
            <div style="background-color: #2979FF; padding: 16px; text-align: center; border-radius: 10px 10px 0 0;">
              <div style="display: flex; align-items: center; justify-content: center;">
                <v-icon color="white" class="mr-2" size="24">mdi-ticket-confirmation</v-icon>
                <span style="color: white; font-weight: 600; font-size: 18px; letter-spacing: 0.5px;">Ingresso Digital</span>
              </div>
            </div>
            <v-card-text style="padding: 24px 20px; background-color: #FFFFFF;">
              <div style="text-align: center; margin-bottom: 16px;">
                <h3 style="margin: 0 0 4px 0; color: #1E3A8A; font-size: 20px; font-weight: 600;">{{ inscricao[0].nome }}</h3>
              </div>
              
              <div style="display: flex; justify-content: center; margin: 20px 0;">
                <div style="border: 1px solid #E0E7FF; padding: 12px; background-color: #FFFFFF; border-radius: 12px; display: inline-block; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <enhanced-qr-code 
                      :value="inscricao[0].cod_incricao" 
                      :size="150"
                      :margin="1"
                      :borderWidth="8"
                      borderColor="#FFFFFF"
                      :borderRadius="8"
                    ></enhanced-qr-code>
                    <p style="margin: 8px 0 0 0; font-size: 13px; font-weight: 500; color: #4B5563; text-align: center;">{{ inscricao[0].cod_incricao }}</p>
                  </div>
                </div>
              </div>
              
              <div v-if="inscricao[0].vagas" style="margin-top: 20px; background-color: #F8FAFC; border-radius: 10px; padding: 16px; border-left: 4px solid #2979FF;">
                <div style="font-weight: 500; color: #4B5563; font-size: 14px; margin-bottom: 10px; display: flex; align-items: center;">
                  <v-icon style="color: #2979FF;" class="mr-2">mdi-seat</v-icon>
                  Vagas Reservadas
                </div>
                <div style="font-size: 15px; color: #1F2937; font-weight: 500; padding-left: 4px;">
                  {{ formatarSetor(inscricao[0].vagas) }}
                </div>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div>
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-calendar</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">{{ eventoSelecionado.nome }}</div>
                </div>
                
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-map-marker</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">
                    {{ eventoSelecionado.local }}
                    <span v-if="eventoSelecionado.localizacao">
                      (<a :href="eventoSelecionado.localizacao" target="_blank" style="color: #2979FF; font-weight: 500;">Ver no mapa</a>)
                    </span>
                  </div>
                </div>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div style="display: flex; align-items: center; margin: 10px 0; padding: 12px; background-color: #F0F9FF; border-radius: 8px; border-left: 4px solid #2979FF;">
                <v-icon color="#2979FF" class="mr-3" size="22">mdi-check-circle</v-icon>
                <span style="font-weight: 600; color: #1E3A8A;">Pagamento realizado com sucesso!</span>
              </div>
              
              <p style="font-size: 13px; color: #6B7280; margin: 12px 0; text-align: left;">
                Guarde este comprovante para sua referência no dia do evento
              </p>
            </v-card-text>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;" v-if="eventoSelecionado.usaCartaoConsumo">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#4B5563"
                :href="'https://aiconsumer.intelite.com.br?cod=' + inscricao[0].cod_incricao">
                <v-icon left>mdi-credit-card-outline</v-icon>
                Cartão Consumo
              </v-btn>
            </v-card-actions>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0"
                @click="dialogoInformacoesGrupo = false">
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
    <loading :active.sync="isLoading" :can-cancel="false" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
/* import vueCard from 'vue-card-express'; */
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import CpfValidate from "../../componentes/validators/rules/cpf";
import CnpjValidate from "../../componentes/validators/rules/cnpj";
import QrcodeVue from "qrcode.vue";
import EnhancedQrCode from "../../componentes/EnhancedQrCode.vue";
import { baseApiUrl /* modelBoleto */ } from "@/global";
import Snackbar from "../../componentes/snackbar.vue";
import { mapState } from "vuex";
import moment from "moment";
import axios from "axios";
export default {
  components: {
    Snackbar,
    QrcodeVue,
    EnhancedQrCode,
    Loading,
  },
  name: "Auth",

  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,

    backgroundStyle() {
      return {
        backgroundImage: `url('${this.eventoSelecionado.urlMapa}')`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
      };
    },

    numbers() {
      return Array.from({ length: 50 }, (_, index) => index + 1);
    }
  }),

  data: function () {
    return {
      vagas: [],
      valorParcela: 0,
      timeout: 4000,
      snackbar: false,
      textoSnackbar: "",
      pagamentoPix: false,
      localPagamento: "",
      eventoId: "",
      cpf: "",
      email: "",
      qtdCompra: 1,
      pagePrincipal: true,
      pagePagamento: false,
      pageConsulta: false,
      PageIncricao: false,
      paginaInscricaoVagas: false,
      maskCartao: "#### #### #### ####",
      user: {},
      cultoSelecionado: "",
      inscricao: [
        {
          cod_incricao: "",
          nome: "",
          cpf: "",
          sexo: "",
          telefone: "",
          eventoId: "",
          lote: 0,
          tipo: "VIRTUAL",
          tipoDocumento: "",
          valorPago: "",
          vagas: [],
          qtdSenhasExtra: 1,
          tamanhoCamisa: "",
        },
      ],
      inscricaoDefault: [
        {
          cod_incricao: "",
          nome: "",
          cpf: "",
          sexo: "",
          telefone: "",
          eventoId: "",
          lote: 0,
          tipo: "VIRTUAL",
          tipoDocumento: "",
          valorPago: "",
          vagas: [],
          qtdSenhasExtra: 1,
          tamanhoCamisa: "",
        },
      ],
      pagamento: {
        valor: 0,
        cartaoNumero: "",
        cvv: "",
        mesVencimento: "",
        anoVencimento: "",
        nomeTitular: "",
        cpfTitular: "",
        bandeira: "",
        cep: "",
        numero: "",
        email: "",
      },
      dialogCancelamento: false,
      dialogoIngressoIndividual: false,
      confirmacaoBoleto: false,
      confirmacaoEmMaos: false,
      qtdInscritos: 0,
      capacidadeEvento: 0,
      reserva: 0,
      sexo: ["MASCULINO", "FEMININO"],
      tipo: ["MEMBRO", "VISITANTE"],
      tamanhos: [],
      quantidade: [],
      mesesVencimento: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      anosVencimento: [],
      eventos: [],
      condicoes: [
        { value: true, text: "SIM" },
        { value: false, text: "NÃO" },
      ],
      necessidades: ["AUDITIVA", "CADEIRANTE", "VISUAL"],
      bandeiras: [
        { value: "DINERS", text: "DINERS" },
        { value: "ELO", text: "ELO" },
        { value: "HIPERCARD", text: "HIPERCARD" },
        { value: "MASTERCARD", text: "MASTERCARD" },
        { value: "VISA", text: "VISA" },
      ],
      parcelas: [],
      modelCartao: {
        id: "",
        valor: "",
        tipoTransacao: "A_VISTA",
        quantidadeParcelas: 1,
        comprador: {
          id: "",
          documentoNumero: "",
          documentoTipo: "1",
          email: "",
          nomeCompleto: "",
          primeiroNome: "",
          ultimoNome: "",
          enderecoLogradouro: "",
          enderecoNumero: "",
          enderecoComplemento: "",
          enderecoCep: "",
          enderecoBairro: "",
          enderecoCidade: "",
          enderecoEstado: "",
        },
        cartao: {
          numero: "",
          codigoSeguranca: "",
          nome: "",
          expiracaoAno: "",
          expiracaoMes: "",
          bandeira: "",
        },
      },
      cobrancaAsaas: {
        customer: "",
        billingType: "",
        value: 0,
        dueDate: "",
        description: "",
      },
      cobrancaAsaasCartao: {
        customer: "",
        billingType: "",
        value: 0,
        dueDate: "",
        description: "",
        remoteIp: "",
        creditCard: {
          holderName: "",
          number: "",
          expiryMonth: "",
          expiryYear: "",
          ccv: "",
        },
        creditCardHolderInfo: {
          name: "",
          email: "",
          cpfCnpj: "",
          postalCode: "",
          addressNumber: "",
          phone: "",
        },
      },
      clienteAsaas: {
        name: "",
        cpfCnpj: "",
        email: "",
        mobilePhone: "",
        postalCode: "",
        addressNumber: "",
        notificationDisabled: true,
      },
      tokenAsaas: "49c4e67d3ee1f8dc149532590589285abc97c9b10a8c3759e9b6f63e383a76d3",
      qrCode64: "",
      chaveCopiaeCola: "",
      empresa: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: "",
      msgResultado: "",
      idInscricao: [],
      codigoAcesso: "",
      informaMunicipio: true,
      idClienteAsaas: "",
      valorAcrescimo: {
        acrescimoBoleto: 0.0,
        acrescimoPix: 0.0,
      },
      qtdInscMasculinas: 0,
      qtdInscFemininas: 0,
      vagasMasculinas: 0,
      vagasFemininas: 0,
      textoParcela: "",
      paginaInscricaoGrupo: false,
      caravana: false,
      inscricaoLocalizada: {
        cod_incricao: "",
        nome: "",
        email: "",
        sexo: "",
        telefone: "",
        eventoNome: "",
        eventoLocal: "",
        eventoLocalizacao: "",
        eventoUsaCartaoConsumo: "",
        setor: "",
        corSetor: "",
      },
      linkBoleto: "",
      consultaCPF: false,
      dialogoToken: false,
      token: "",
      divulgador: [],
      indicacao: false,
      possuiCupom: false,
      cupomDesconto: "",
      cupomAplicado: false,
      loader: null,
      loadingCupom: false,
      dadosCupom: [],
      qtdParcelas: null,
      usaCupomDesconto: null,
      tipoIngresso: "",
      eventoSelecionado: [],
      usaCartaoConsumo: null,
      bloqueiaVoltar: false,
      estados: [],
      municipios: [],
      tiposDocumento: ["CPF", "CNPJ"],
      valorTotalCompra: 0,
      aceiteLgpd: false,
      dialogoListaIngresso: false,
      clickedCells: [],
      exibeMapa: false,
      exibeNumero: false,
      x: 0,
      matrix: [],
      vagasSelecionadas: '',
      inscricoesExtras: [],
      exibirQRCode: false,
      dictionary: {
        custom: {
          nomeCartao: {
            required: () => "Informe o nome",
          },
          numCartao: {
            required: () => "Informe o número do cartão de crédito",
          },
          cpftitular: {
            required: () => "Informe o número do cartão de crédito",
          },
          codCartao: {
            required: () => "Informe o código de segurança",
          },
          expiraCartaoMes: {
            required: () => "Informe o mês de validade do cartão",
          },
          expiraCartaoAno: {
            required: () => "Informe o ano de validade do cartão",
          },
          dateOfBirth: {
            required: () => "Informe a Data de Nascimento",
            date_format: () => "Informe uma data válida (dd/mm/aaaa)",
          },
        },
      },
      headersIngressos: [
        { text: 'Nome', value: 'nome', align: 'start' },
        { text: 'Código', value: 'cod_incricao', align: 'center' },
        { text: 'Ações', value: 'action', align: 'end', sortable: false },
      ],
    };
  },

  mounted: async function () {
    await this.carregaDados();
    this.pegaParametrosUrl();
    this.$validator.localize("pt", this.dictionary);
    this.buscaUfs();
    this.buscaMunicipios();
  },

  watch: {
    dialogoIngressoIndividual(val) {
      if (val == false) {
        setTimeout(() => {
          let keys = Object.keys(this.inscricaoLocalizada);

          for (let i = 0; i < keys.length; i++) {
            this.inscricaoLocalizada[keys[i]] = "";
          }
        }, 300);
      }
    },

    dialogoListaIngresso(val) {
      if (val == false) {
        this.inscricao = Object.assign({}, this.inscricaoDefault);
        this.pagePrincipal = true;
        this.paginaInscricaoGrupo = false;
        this.pagePagamento = false;
        this.idInscricao = [];
      }
    },
  },

  methods: {
    retornaMunicipios(uf) {
      return this.municipios.filter(
        (municipios) => municipios["UF-sigla"] === uf
      );
    },

    criarQuantidades(minimo, maximo) {
      this.quantidade = []

      for (let i = 0; i < 51; i++) {
        if (i >= minimo && i <= maximo) {
          this.quantidade.push(i)
        }
      }
    },

    criarAnosVencimento() {
      this.anosVencimento = [];
      let anoAtual = new Date().toISOString().substring(0, 4);
      let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14;

      while (anoAtual <= anoFinal) {
        this.anosVencimento.push((anoAtual++).toString());
      }
    },

    doCopy(id) {
      try {
        let copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
        document.execCommand("copy");
        this.snackbar = true;
        this.textoSnackbar = "Chave copiada para a área de transferência!";
      } catch (error) {
        this.snackbar = true;
        this.textoSnackbar =
          "Problema ao copiar chave para a área de transferência";
      }
    },

    reloadPage() {
      window.location.reload();
    },

    async carregaDados() {
      this.eventos = [];
      this.isLoading = true;

      await axios.post(baseApiUrl + "eventos/eventosFuturos", { empresaId: "669a5e239fc74062129f80da" })
        .then(async (response) => {
          this.eventos = response.data.eventos;
          this.empresa = response.data.empresa;
          this.isLoading = false;
        });
    },

    calculaValorTotalCartao(evento) {
      let valorTotal;

      if (this.inscricao.length < 15) {
        valorTotal = parseFloat(evento.valorCartao.replace(",", ".") * this.inscricao.length);
        return parseFloat(valorTotal);
      } else {
        valorTotal = parseFloat(evento.valorCartao.replace(",", ".") * this.inscricao.length);
        return parseFloat(parseFloat(valorTotal - 55));
      }
    },

    calculaParcelas(evento, qtdCompra) {
      if (evento.valorCartao) {
        if (evento || qtdCompra) {
          let valorTotal

          // Usa o valor total calculado baseado nos setores, se disponível
          let valorBase = this.valorTotalCompra;
          if (typeof valorBase === 'string') {
            valorBase = parseFloat(valorBase.replace(",", "."));
          }
          
          // Se não há valor total calculado, calcula baseado no evento
          if (!valorBase || valorBase === 0) {
            // Tenta calcular baseado nas inscrições/cadeiras selecionadas
            if (this.inscricao && this.inscricao[0] && (this.inscricao[0].vagas || this.inscricao[0].qtdSenhasExtra)) {
              valorBase = this.calculaValorInscricoes("valorCartao");
            }
            // Se ainda não tem valor (não há cadeiras selecionadas), usa o valor do cartão do evento diretamente
            if (!valorBase || valorBase === 0) {
              valorBase = parseFloat((evento.valorCartao || "0").replace(",", "."));
            }
          }

          // Pega o acréscimo da última parcela
          const acrescimo = parseFloat((evento['acrescimoCartao' + evento.quantidadeParcelas] || "0").replace(",", "."));

          if (qtdCompra) {
            valorTotal = (valorBase / qtdCompra) + acrescimo
            valorTotal = valorTotal * qtdCompra
            valorTotal = parseFloat(valorTotal / evento.quantidadeParcelas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
          } else {
            valorTotal = valorBase + acrescimo
            valorTotal = parseFloat(valorTotal / evento.quantidadeParcelas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
          }
          return valorTotal
        }
      }
    },

    criarParcelas(qtdCompra) {
      this.parcelas = []

      // Verifica se há cadeiras selecionadas de setores diferentes
      const temCadeirasSetoresDiferentes = this.eventoSelecionado.matrizLinha && 
                                            this.eventoSelecionado.matrizColuna && 
                                            this.inscricao[0].vagas && 
                                            this.inscricao[0].vagas.length > 0 &&
                                            this.eventoSelecionado.setores &&
                                            this.eventoSelecionado.setores.length > 0;

      for (let i = 0; i < this.qtdParcelas; i++) {
        // incrementa o índice do for para usar como número da parcela
        let numeroParcela = (i + 1)
        let valorTotal = 0;

        if (temCadeirasSetoresDiferentes) {
          // Calcula para cada cadeira: valor base do setor + acréscimo do setor para a parcela
          for (let j = 0; j < this.inscricao[0].vagas.length; j++) {
            const vaga = this.inscricao[0].vagas[j];
            if (vaga.setor && this.eventoSelecionado.setores) {
              const setor = this.eventoSelecionado.setores.find(s => s.nome === vaga.setor);
              if (setor) {
                // Valor base do setor (valorCartao ou valor)
                const valorBaseSetor = parseFloat((setor.valorCartao || setor.valor || this.eventoSelecionado.valorCartao || "0").replace(',', '.'));
                
                // Acréscimo do setor para esta parcela
                const acrescimoSetor = parseFloat((setor['acrescimoCartao' + numeroParcela] || "0").replace(',', '.'));
                
                // Soma valor base + acréscimo para esta cadeira
                valorTotal += valorBaseSetor + acrescimoSetor;
              } else {
                // Se não encontrou o setor, usa valor padrão do evento + acréscimo padrão
                const valorBase = parseFloat((this.eventoSelecionado.valorCartao || "0").replace(',', '.'));
                const acrescimo = parseFloat((this.eventoSelecionado['acrescimoCartao' + numeroParcela] || "0").replace(',', '.'));
                valorTotal += valorBase + acrescimo;
              }
            } else {
              // Se não tem setor, usa valor padrão do evento + acréscimo padrão
              const valorBase = parseFloat((this.eventoSelecionado.valorCartao || "0").replace(',', '.'));
              const acrescimo = parseFloat((this.eventoSelecionado['acrescimoCartao' + numeroParcela] || "0").replace(',', '.'));
              valorTotal += valorBase + acrescimo;
            }
          }
        } else {
          // Lógica original para quando não há cadeiras de setores diferentes
          let valorBaseTotal = this.valorTotalCompra;
          if (typeof valorBaseTotal === 'string') {
            valorBaseTotal = parseFloat(valorBaseTotal.replace(',', '.'));
          }

          // Calcula o valor individual com acréscimo baseado no valor total
          let valorIndividual = valorBaseTotal / qtdCompra;
          let valorIndividualComAcrescimo = valorIndividual + parseFloat(this.valorAcrescimo['acrescimoCartao' + numeroParcela].replace(',', '.'))

          // multiplica o valor individual com acréscimo com a quantidade a ser adquirida
          valorTotal = (valorIndividualComAcrescimo * qtdCompra)
        }

        // divide o valor total pelo número da parcela
        let valorParcela = valorTotal / numeroParcela

        // cria a string contendo todas as informações necessárias
        let textoParcela = numeroParcela + 'X de R$ ' + valorParcela.toFixed(2).replace('.', ',') + ' (Total R$ ' + valorTotal.toFixed(2).replace('.', ',') + ')'

        this.parcelas.push(textoParcela)
      }
    },

    cancelarPagamento() {
      //this.removeCupom()
      this.pagePagamento = false;

      if (this.eventoSelecionado.matrizColuna && this.eventoSelecionado.matrizLinha) {
        this.paginaInscricaoVagas = true;
      } else {
        this.paginaInscricaoGrupo = true;
      }
    },

    /* formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      }, */

    formatDatePadrao(date) {
      if (!date) return null;

      const [day, month, year] = date.substr(0, 10).split("/");
      return `${year}-${month}-${day}` + " " + date.substr(11, 6);
    },

    formatDateBrz(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDateHora(date) {
      if (!date) return null;

      const [year, month, day] = date.substr(0, 10).split("-");
      return `${day}/${month}/${year}` + " " + date.substr(11, 5) + 'h';
    },

    async acessaConsulta() {
      this.pagePrincipal = false;
      this.pageConsulta = true;
    },

    async solicitaCancelamento() {
      this.pagePrincipal = false;
      this.pageConsulta = true;
      if (
        this.inscricao.nome == "" ||
        this.eventoId == "" ||
        this.inscricao.cpf == ""
      ) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha os campos: Evento, Nome e CPF para solicitar o cancelamento!",
          "ATENÇÃO"
        );
      } else {
        this.isLoading = false;
        this.dialogCancelamento = true;
      }
    },

    async realizarCancelamento() {
      this.idInscricao = "";
      this.isLoading = true;
      try {
        let res = await axios.get(
          `${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"cpf":"${this.inscricao.cpf}"}]}}`
        );
        if (res.data[0].id) {
          this.idInscricao = res.data[0].id;
        } else {
          this.isLoading = false;
          this.dialogCancelamento = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Não foi possível localizar a inscrição, verifique os dados e tente novamente!",
            "ATENÇÃO"
          );
        }
      } catch (error) {
        this.isLoading = false;
        this.dialogCancelamento = false;
        vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Não foi possível localizar a inscrição, verifique os dados e tente novamente!",
          "ATENÇÃO"
        );
      }
      if (this.idInscricao != "") {
        try {
          let res = await axios.delete(
            `${baseApiUrl}Inscricoes/${this.idInscricao}`
          );
          if (res.data != "") {
            this.isLoading = false;
            this.inscricao = Object.assign({}, this.inscricaoDefault);
            this.dialogCancelamento = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Cancelamento realizado com sucesso!",
              "INFORMAÇÃO"
            );
          } else {
            this.isLoading = false;
            this.dialogCancelamento = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!",
              "ATENÇÃO"
            );
          }
        } catch (error) {
          this.isLoading = false;
          this.dialogCancelamento = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!",
            "ATENÇÃO"
          );
        }
      }
    },

    async aplicaCupom() {
      var vm = this;

      if (this.cupomDesconto) {
        await axios.get(baseApiUrl + 'Cupons?filter={"where":{"nome":"' + this.cupomDesconto.toUpperCase().trim() + '"}}')
          .then((response) => {
            if (response.data) {
              if (response.data[0].nome.toUpperCase() == this.cupomDesconto.toUpperCase().trim() && response.data[0].quantidade > response.data[0].utilizados) {
                this.dadosCupom = response.data[0];
                this.cupomAplicado = true;
                this.valorTotalCompra = parseFloat(parseFloat(this.valorTotalCompra) - parseFloat(this.dadosCupom.valor)).toFixed(2).replace(".", ",");
              }
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#F9A825", "Cupom inválido ou esgotado!", "ATENÇÃO");
          });
      }
    },

    removeCupom() {
      this.valorTotalCompra = parseFloat(parseFloat(this.valorTotalCompra) + parseFloat(this.dadosCupom.valor)).toFixed(2).replace(".", ",");
      this.cupomAplicado = false;
      this.dadosCupom = [];
      this.possuiCupom = false;
      this.cupomDesconto = "";
    },

    async atualizaCupomsUtilizados() {
      await axios.patch(baseApiUrl + "Cupons/" + this.dadosCupom.id, {
        utilizados: this.dadosCupom.utilizados + 1,
      });
    },

    carregaQtdParcelas() {
      for (let i = 0; i < this.parcelas.length; i++) {
        if (this.pagamento.valorEscolhido == this.parcelas[i]) {
          this.cobrancaAsaasCartao.installmentCount = parseInt(
            this.parcelas[i].split("X")[0]
          );
          this.textoParcela = this.parcelas[i];

          const parcela = this.parcelas[i];
          const match = parcela.match(/\(Total R\$\s*([\d,]+)\)/);

          if (match && match[1]) {
            const valorTotal = match[1].replace(",", ".");
            this.pagamento.valor = valorTotal;
            // Atualiza valorTotalCompra para exibir corretamente nos detalhes da compra
            this.valorTotalCompra = parseFloat(valorTotal).toFixed(2).replace(".", ",");
          }
        }
      }
    },

    async prosseguirPagamento(formaPagamento) {
      let vm = this;
      let inscricoesValidas = [];
      await this.pegaVagasDisponiveis();
      await this.pegaCamisas(this.eventoSelecionado.id)

      if (!this.aceiteLgpd) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, concorde com as políticas de privacidade e tratamento de dados pessoais", "ATENÇÃO");
        return;
      }

      if (this.eventoSelecionado.matrizColuna && this.eventoSelecionado.matrizLinha && (!this.inscricao[0].vagas || this.inscricao[0].vagas.length == 0)) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, selecione pelo menos uma cadeira", "ATENÇÃO");
        return;
      }
      
      if (this.inscricoesExtras.length > 0) {
        let campoEmBranco = false

        for (let i = 0; i < this.inscricoesExtras.length; i++) {
          if (!this.inscricoesExtras[i].nome || !this.inscricoesExtras[i].tamanhoCamisa) {
            campoEmBranco = true
            break;
          }
        }

        if (campoEmBranco) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO");
          return
        }
      }

      for (let i = 0; i < this.inscricao.length; i++) {
        // this.inscricao[i].setor = this.eventoSelecionado.setores[0].nome;
        // this.inscricao[i].corSetor = this.eventoSelecionado.setores[0].cor;

        if (!this.inscricao[0].telefone) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Informe um WhatsApp com DDD", "ATENÇÃO");
          return;
        }

        // verifica tipoDocumento da inscrição e se todas as informações estão preenchidas
        if (this.inscricao[i].tipoDocumento == "CPF" && !this.validarCamposInscricaoCPF(this.inscricao[i])) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente do " + (i + 1) + "º participante para confirmar a inscrição!", "ATENÇÃO");
          break;
        }
        else if (this.inscricao[i].tipoDocumento == "CNPJ" && !this.validarCamposInscricaoCNPJ(this.inscricao[i])) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente do " + (i + 1) + "º participante para confirmar a inscrição!", "ATENÇÃO");
          break;
        }
        else {
          /* if (this.vagasDisponiveis[this.inscricao[i].setor] > 0) { */
          inscricoesValidas.push(this.inscricao[i]);
          /* } else {
            vm.$refs.chamaSnackbar.snack("#F9A825", "Quantidade máxima do setor selecionado para o " + (i + 1) + "º participante foi atingido. Selecione outro setor.", "ATENÇÃO");
            break;
          } */
        }
      }

      let continuarCamisas = this.verificaCamisasSelecionadas([...this.inscricao, ...this.inscricoesExtras], this.tamanhos)

      if (continuarCamisas != true) {
        vm.$refs.chamaSnackbar.snack("#F9A825", continuarCamisas, "ATENÇÃO");
        return
      }

      if (inscricoesValidas.length === this.inscricao.length) {
        if (formaPagamento == "CARTÃO") {
          // Chama pegarAcrescimosSetores quando há setores diferentes (limite por setor ou cadeiras de setores diferentes)
          if (this.empresa.limiteInscricao == "SETOR" || 
              (this.eventoSelecionado.matrizLinha && this.eventoSelecionado.matrizColuna && 
               this.inscricao[0].vagas && this.inscricao[0].vagas.length > 0 && 
               this.eventoSelecionado.setores && this.eventoSelecionado.setores.length > 0)) {
            await this.pegarAcrescimosSetores();
          }
          if (this.eventoSelecionado.valorCartao) {
            this.valorTotalCompra = this.calculaValorInscricoes("valorCartao");
          }
          this.criarAnosVencimento();

          if (this.eventoSelecionado.matrizLinha && this.eventoSelecionado.matrizColuna) {
            this.criarParcelas(this.inscricao[0].vagas.length);
          } else {
            this.criarParcelas(this.inscricao[0].qtdSenhasExtra);
          }

          if (this.paginaInscricaoGrupo) {
            this.paginaInscricaoGrupo = false;
          }

          if (this.paginaInscricaoVagas) {
            this.paginaInscricaoVagas = false;
          }

          this.pagePagamento = true;
        } else if (formaPagamento == "PIX") {
          if (this.eventoSelecionado.valorPix) {
            this.valorTotalCompra = this.calculaValorInscricoes("valorPix");
          }

          this.callFunctionPixPayment()
        } else if (formaPagamento == "BOLETO") {
          this.pagamentoBoleto();
        }
      }
    },

    validarCamposInscricaoCPF(inscricao) {
      if (
        inscricao.nome.trim() === "" ||
        inscricao.cpf.trim() === "" ||
        !CpfValidate(inscricao.cpf) ||
        inscricao.telefone.trim() === "" ||
        inscricao.tamanhoCamisa === ""
      ) {
        return false;
      } else {
        return true;
      }
    },

    validarCamposInscricaoCNPJ(inscricao) {
      if (
        inscricao.nome.trim() === "" ||
        inscricao.cpf.trim() === "" ||
        !CnpjValidate(inscricao.cpf) ||
        inscricao.telefone.trim() === "" ||
        inscricao.tamanhoCamisa === ""
      ) {
        return false;
      } else {
        return true;
      }
    },

    verificaCamisasSelecionadas(escolhidas, estoque) {
      let contagemEscolhidas = escolhidas.reduce((acc, item) => {
        if (!acc[item.tamanhoCamisa]) {
          acc[item.tamanhoCamisa] = 0;
        }

        acc[item.tamanhoCamisa]++;
      
        return acc;
      }, {});

      let tamanhosEsgotados = [];
      // let tamanhosNaoEscolhidos = estoque.map(e => e.tamanho).filter(t => !(t in contagemEscolhidas));
      let tamanhosNaoEscolhidos = escolhidas.filter(inscricao => !inscricao.tamanhoCamisa);

      let podeComprar = Object.entries(contagemEscolhidas).every(([tamanho, qtdEscolhida]) => {
        let itemEstoque = estoque.find(e => e.tamanho === tamanho);
        if (!itemEstoque || itemEstoque.quantidade < qtdEscolhida) {
          tamanhosEsgotados.push(tamanho);
          return false;
        }
        return true;
      });

      let formatarTamanhos = (tamanhos) => {
        if (tamanhos.length === 0) return "";
        if (tamanhos.length === 1) return tamanhos[0];
        return tamanhos.slice(0, -1).join(", ") + " e " + tamanhos[tamanhos.length - 1];
      };

      if (tamanhosNaoEscolhidos.length > 0) {
        return 'Escolha um tamanho de camisa para todas as vagas selecionadas!'
      } else if (podeComprar) {
        return true
      } else {
        return (`Estoque insuficiente para os tamanhos: ${formatarTamanhos(tamanhosEsgotados)}`);
      }
    },

    calculaValorInscricoes(chave) {
      let valor = 0;

      // Se há cadeiras selecionadas, calcular baseado nos setores
      if (this.eventoSelecionado.matrizLinha && this.eventoSelecionado.matrizColuna && this.inscricao[0].vagas && this.inscricao[0].vagas.length > 0) {
        // Calcula o valor somando os valores dos setores de cada cadeira selecionada
        for (let i = 0; i < this.inscricao[0].vagas.length; i++) {
          const vaga = this.inscricao[0].vagas[i];
          if (vaga.setor && this.eventoSelecionado.setores) {
            // Busca o setor correspondente
            const setor = this.eventoSelecionado.setores.find(s => s.nome === vaga.setor);
            if (setor) {
              // Usa o valor do setor baseado na chave (valorPix ou valorCartao)
              // Se o setor tem valor específico, usa ele, senão usa o valor do evento
              if (chave == "valorPix") {
                valor += parseFloat((setor.valorPix || setor.valor || this.eventoSelecionado.valorPix || "0").replace(",", "."));
              } else if (chave == "valorCartao") {
                valor += parseFloat((setor.valorCartao || setor.valor || this.eventoSelecionado.valorCartao || "0").replace(",", "."));
              }
            } else {
              // Se não encontrou o setor, usa o valor padrão do evento
              valor += parseFloat((this.eventoSelecionado[chave] || "0").replace(",", "."));
            }
          } else {
            // Se não tem setor, usa o valor padrão do evento
            valor += parseFloat((this.eventoSelecionado[chave] || "0").replace(",", "."));
          }
        }
      } else {
        // Se não há cadeiras selecionadas, usa o valor padrão multiplicado pela quantidade
        if (chave == "valorPix") {
          valor = parseFloat((this.eventoSelecionado[chave] || "0").replace(",", ".")) * (this.inscricao[0].qtdSenhasExtra || 1);
        } else if (chave == "valorCartao") {
          valor = parseFloat((this.eventoSelecionado[chave] || "0").replace(",", ".")) * (this.inscricao[0].qtdSenhasExtra || 1);
        }
      }

      for (let i = 0; i < this.inscricao.length; i++) {
        if (this.inscricao[i].tipoDocumento == "CNPJ" && this.eventoSelecionado.desconto) {
          valor -= parseFloat(this.eventoSelecionado.desconto.replace(",", "."));
        }
      }

      return valor;
    },

    async realizarInscricaoPagamento() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.criarAnosVencimento();
            this.criarParcelas();
            this.isLoading = false;
            this.pagePrincipal = false;
            this.paginaInscricaoGrupo = false;
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.criarAnosVencimento();
            this.criarParcelas();
            this.isLoading = false;
            this.pagePrincipal = false;
            this.PageIncricao = false;
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoBoleto() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.pagamentoBoleto();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.pagamentoBoleto();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoEmMaos() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      if (await this.validaVagas()) {
        if (
          this.inscricao.dataNascimento != "" &&
          this.calculateAge(this.formatDate(this.inscricao.dataNascimento)) < 16
        ) {
          this.isLoading = false;
          var vm2 = this;
          vm2.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Só é permitido a inscrição de maiores de 16 anos!",
            "ATENÇÃO"
          );
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf)
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.inscricao.statusPagamento = "PENDENTE";
            this.inscricao.formOfPayment = "EM MAOS";
            this.inscricao.valorPago = "330,00";
            this.realizarInscricao(this.finalizaInscricao);
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoPix() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.callFunctionPixPayment()
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.callFunctionPixPayment()
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    realizarInscricaoAgora() {
      this.pagePrincipal = false;
      this.PageIncricao = true;
      this.validaVagas();
      this.verificaCapacidade();
    },

    generateMatrix() {
      this.matrix = [];

      for (let i = 0; i < this.eventoSelecionado.matrizLinha; i++) {
        const row = [];
        for (let j = 0; j < this.eventoSelecionado.matrizColuna; j++) {
          const localizacao = i * this.eventoSelecionado.matrizColuna + j + 1;
          row.push({
            localizacao,
            active: false,
            status: "LIVRE",
            tipo: "",
            vaga: "",
            empresaId: '',
            eventoId: '',
            setor: '',
          });
        }
        this.matrix.push(row);
      }

      // Espera a matriz ser criada e então carrega as vagas e atualiza a matriz
      this.$nextTick(() => {
        this.adjustBackgroundSize();
        this.getVagas().then(() => {
          this.updateMatrixCells(); // Atualiza a matriz com os dados recém carregados
        });
      });
    },

    updateMatrixCells() {
      let updatedMatrix = this.matrix.map(
        (row) => row.map((cell) => {
          // Converte `cell.localizacao` para número, se ainda não for, e compara com a `localizacao` de `clickedCells` convertida para número
          const found = this.clickedCells.find(
            (c) => parseInt(c.localizacao) === cell.localizacao
          );

          if (found) {
            // Se encontrada, atualiza a célula com os dados da vaga encontrada e marca como ativa
            return { ...cell, ...found, active: true };
          }

          return cell; // Retorna a célula como está se não encontrar correspondência
        })
      );

      this.matrix = updatedMatrix; // Substitui a matriz antiga pela nova para forçar a reatividade
      // console.log("Matriz atualizada com vagas marcadas:", this.matrix);
    },

    async realizarInscricaoGrupo(evento) {
      this.eventoSelecionado = evento;
      this.tipoIngresso = evento.nome;
      this.caravana = true;
      this.pagePrincipal = false;

      if (evento.matrizColuna && evento.matrizLinha) {
        this.paginaInscricaoVagas = true
      } else {
        this.paginaInscricaoGrupo = true
      }

      if (evento.tamanhosCamisa) {
        this.pegaCamisas(evento.id)
      }

      this.inscricao = [];
      for (let i = 0; i < evento.vendaMinima; i++) {
        this.inscricao.push({
          cod_incricao: "",
          nome: "",
          cpf: "",
          email: "",
          sexo: "",
          telefone: "",
          eventoId: "",
          lote: "",
          tipo: "VIRTUAL",
          tipoDocumento: evento.tipoDocumento == "AMBOS" ? evento.documentoPadrao : evento.tipoDocumento,
          valorPago: "",
          qtdSenhasExtra: 1,
          tamanhoCamisa: "",
        });
      }

      this.eventoId = evento.id;
      this.valorAcrescimo.acrescimoBoleto = evento.acrescimoBoleto;
      this.valorAcrescimo.acrescimoPix = evento.acrescimoPix;

      let keys = Object.keys(evento);
      keys = keys.filter((k) => k.includes("acrescimoCartao"));

      for (let i = 0; i < evento.quantidadeParcelas; i++) {
        if (keys[i]) {
          this.valorAcrescimo[keys[i]] = evento[keys[i]];
        } else {
          this.valorAcrescimo["acrescimoCartao" + (i + 1)] = "0,00";
        }
      }

      this.qtdParcelas = evento.quantidadeParcelas;
      this.usaCupomDesconto = evento.usaCupomDesconto;
      this.criarQuantidades(evento.vendaMinima, evento.vendaMaxima)
      this.qtdCompra = evento.vendaMinima;
      // await this.verificaCapacidade()

      for (let i = 0; i < this.inscricao.length; i++) {
        if (evento.tipoDocumento == "AMBOS") {
          this.inscricao[i].tipoDocumento = evento.documentoPadrao;
        } else {
          this.inscricao[i].tipoDocumento = evento.tipoDocumento;
        }
      }

      this.valorTotalCompra = 0;

      if (this.empresa.limiteInscricao == "SETOR") {
        this.pegaVagasDisponiveis();
      }
    },

    async pegaCamisas(eventoId) {
      await axios.post(baseApiUrl + 'eventos/camisasLivres', {"eventoId": eventoId})
      .then(response => {
        if (response.data) {
          for (let i = 0; i < response.data.length; i++) {
            if (!response.data[0].quantidade) {
              response.data[0].desativado = true
            }
          }
          
          this.tamanhos = response.data
        }
      })
    },

    async verificaCamisa(tamnahoSelecionado, chave, indice) {
      let vm = this
      await this.pegaCamisas(this.eventoSelecionado.id)

      for (let i = 0; i < this.tamanhos.length; i++) {
        if (this.tamanhos[i].tamanho == tamnahoSelecionado && this.tamanhos[i].quantidade <= 0) {
          this[chave][indice].tamanhoCamisa = ''
          vm.$refs.chamaSnackbar.snack("#F9A825", "Tamanho escolhido esgotado!", "ATENÇÃO");
        }
      }
    },

    async verificaDocumento(cpf, index, tipo) {
      let vm = this;
      let jaExiste = false;

      if ((tipo == "CNPJ" && !CnpjValidate(cpf)) || (tipo == "CPF" && !CpfValidate(cpf))) {
        return;
      }

      if (this.verificaCpfInformado(cpf, index)) {
        jaExiste = true;
        this.inscricao[index].cpf = "";
        vm.$refs.chamaSnackbar.snack("#F9A825", "CPF não pode ser o mesmo de um já informado!", "ATENÇÃO");
      }

      if (!jaExiste) {
        await axios.post(baseApiUrl + "inscricoes/consultarInscricaoCPF", { cpf: cpf, eventoId: this.eventoSelecionado.id })
          .then((response) => {
            if (response.data.length > 0) {
              if (Object.keys(response.data[0]).includes("statusPagamento")) {
                // this.inscricao[index].cod_incricao = response.data[0].cod_incricao;
                this.inscricao[index].cpf = response.data[0].cpf;
                this.inscricao[index].nome = response.data[0].nome;
                this.inscricao[index].telefone = response.data[0].telefone;
                this.inscricao[index].email = response.data[0].email;
                this.inscricao[index].dataNascimento = response.data[0].dataNascimento;
                this.inscricao[index].estado = response.data[0].estado;
                this.inscricao[index].cidade = response.data[0].cidade;
                this.inscricao[index].valorPago = response.data[0].valorPago;
                this.inscricao[index].tipoDocumento = response.data[0].tipoDocumento;
                this.inscricao[index].filho = this.listaFilhos(response.data)
                // this.inscricao[index].id = response.data[0].id;
              } else {
                this.inscricao[index].nome = response.data[0].nome ? response.data[0].nome : "";
                this.inscricao[index].cpf = response.data[0].cpf ? response.data[0].cpf : "";
                this.inscricao[index].dataNascimento = response.data[0].dataNascimento ? response.data[0].dataNascimento : "";
                this.inscricao[index].telefone = response.data[0].telefone ? response.data[0].telefone : "";
                this.inscricao[index].email = response.data[0].email ? response.data[0].email : "";
              }

            }
          });

        this.exibeMapa = true
        this.generateMatrix()
      }
    },

    listaFilhos(lista) {
      let filhos = []

      for (let i = 0; i < lista.length; i++) {
        for (let j = 0; j < lista[i].filho.length; j++) {
          filhos.push(lista[i].filho[j])
        }
      }

      return filhos
    },

    verificaCpfInformado(cpf, indice) {
      let cpfLocalizado = false;

      for (let i = 0; i < this.inscricao.length; i++) {
        if (i != indice) {
          if (this.inscricao[i].cpf == cpf) {
            cpfLocalizado = true;
            break;
          }
        }
      }

      return cpfLocalizado;
    },

    async validaVagas() {
      var vm = this;

      try {
        await axios.get(baseApiUrl + 'inscricoes/count?where={"and":[{"eventoId":"' + this.eventoId + '"},{"sexo":"MASCULINO"}]}')
          .then((response) => {
            if (response.data) {
              this.qtdInscMasculinas = response.data.count;
            }
          });

        await axios.get(baseApiUrl + 'inscricoes/count?where={"and":[{"eventoId":"' + this.eventoId + '"},{"sexo":"FEMININO"}]}')
          .then((response) => {
            if (response.data) {
              this.qtdInscFemininas = response.data.count;
            }
          });

        /* let res = await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`)
          if (res.data.length > 0)
            res.data.forEach(insc => {
              if (insc.sexo == 'MASCULINO')
                this.qtdInscMasculinas = this.qtdInscMasculinas + 1
              else if (insc.sexo == 'FEMININO')
                this.qtdInscFemininas = this.qtdInscFemininas + 1
            }); */

        if (this.inscricao.sexo == "MASCULINO") {
          //this.qtdInscMasculinas = this.vagasMasculinas
          if (this.qtdInscMasculinas == this.vagasMasculinas) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas para homens foram esgotadas!", "INFORMAÇÃO");
            return false;
          } else {
            this.isLoading = false;
            return true;
          }
        } else if (this.inscricao.sexo == "FEMININO") {
          if (this.qtdInscFemininas == this.vagasFemininas) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas para mulheres foram esgotadas!", "INFORMAÇÃO");
            return false;
          } else {
            this.isLoading = false;
            return true;
          }
        } else {
          this.isLoading = false;
          return true;
        }
      } catch (error) {
        //
      }
    },

    async realizarInscricao(callback = null, formaPagamento, textoParcela) {
      this.isLoading = true;
      let vm = this;

      for (let i = 0; i < this.inscricao.length; i++) {
        // só preenche com cod_incricao quando for nova inscrição
        if (!this.inscricao[i].cod_incricao) {
          this.inscricao[i].cod_incricao = await this.verificaCodInscricao();
        }

        this.inscricao[i].eventoId = this.eventoSelecionado.id;
        this.inscricao[i].statusPagamento = "PENDENTE";
        this.inscricao[i].empresaId = this.empresa.id;
        this.inscricao[i].email = this.inscricao[i].email.toLowerCase().trim();
        this.inscricao[i].formOfPayment = formaPagamento;
        this.inscricao[i].parcelas = textoParcela;
        this.inscricao[i].divulgadorId = this.indicacao ? this.divulgador.id : undefined;
        this.inscricao[i].lote = this.eventoSelecionado.lote;
        this.inscricao[i].updateCron = false;
        this.inscricao[i].nome = this.inscricao[i].nome.toUpperCase()

        if (!this.inscricao[i].valorPago) {
          let valorCalculado = 0;
          
          if (formaPagamento == "CARTAO") {
            if (this.eventoSelecionado.matrizColuna && this.eventoSelecionado.matrizLinha && this.inscricao[0].vagas && this.inscricao[0].vagas.length > 0) {
              // Calcula o valor baseado nos setores das cadeiras selecionadas
              for (let j = 0; j < this.inscricao[0].vagas.length; j++) {
                const vaga = this.inscricao[0].vagas[j];
                if (vaga.setor && this.eventoSelecionado.setores) {
                  const setor = this.eventoSelecionado.setores.find(s => s.nome === vaga.setor);
                  if (setor) {
                    valorCalculado += parseFloat((setor.valorCartao || setor.valor || this.eventoSelecionado.valorCartao || "0").replace(',', '.'));
                  } else {
                    valorCalculado += parseFloat((this.eventoSelecionado.valorCartao || "0").replace(',', '.'));
                  }
                } else {
                  valorCalculado += parseFloat((this.eventoSelecionado.valorCartao || "0").replace(',', '.'));
                }
              }
            } else {
              valorCalculado = parseFloat((this.eventoSelecionado.valorCartao || "0").replace(',', '.')) * (this.inscricao[0].qtdSenhasExtra || 1);
            }
          } else if (formaPagamento == "PIX") {
            if (this.eventoSelecionado.matrizColuna && this.eventoSelecionado.matrizLinha && this.inscricao[0].vagas && this.inscricao[0].vagas.length > 0) {
              // Calcula o valor baseado nos setores das cadeiras selecionadas
              for (let j = 0; j < this.inscricao[0].vagas.length; j++) {
                const vaga = this.inscricao[0].vagas[j];
                if (vaga.setor && this.eventoSelecionado.setores) {
                  const setor = this.eventoSelecionado.setores.find(s => s.nome === vaga.setor);
                  if (setor) {
                    valorCalculado += parseFloat((setor.valorPix || setor.valor || this.eventoSelecionado.valorPix || "0").replace(',', '.'));
                  } else {
                    valorCalculado += parseFloat((this.eventoSelecionado.valorPix || "0").replace(',', '.'));
                  }
                } else {
                  valorCalculado += parseFloat((this.eventoSelecionado.valorPix || "0").replace(',', '.'));
                }
              }
            } else {
              valorCalculado = parseFloat((this.eventoSelecionado.valorPix || "0").replace(',', '.')) * (this.inscricao[0].qtdSenhasExtra || 1);
            }
          }
          
          this.inscricao[i].valorPago = valorCalculado.toFixed(2).replace('.', ',');
        }

        if (this.inscricoesExtras.length > 0) {
          this.inscricao[i].detalhes = await this.criaDetalhesInscricoes()
        }
      }

      await axios.post(baseApiUrl + "inscricoes/criarInscricoes", this.inscricao)
        .then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            for (let j = 0; j < this.inscricao.length; j++) {
              if (this.inscricao[j].cpf == response.data[i].cpf) {
                this.idInscricao.push(response.data[i].id);
                this.inscricao[j].id = response.data[i].id;
              }
            }
          }

          if (callback) {
            callback();
          }
        })
        .catch(() => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar cadastro, tente novamente", "ERRO");
        });
    },

    async verificaCodInscricao() {
      let codInscricao = new Date().getTime().toString();
      let codigoRetornado;

      await axios.post(baseApiUrl + "inscricoes/consultarInscricaoCodigo", { cod_incricao: codInscricao })
        .then(async (response) => {
          if (response.data) {
            await this.verificaCodInscricao();
          }
        })
        .catch((error) => {
          if (error.response.data.error.message.includes("não localizada")) {
            codigoRetornado = codInscricao;
          }
        });

      return codigoRetornado;
    },

    criaDetalhesInscricoes() {
      let resultado = "";

      this.inscricoesExtras.forEach((vaga, index) => {
        resultado += vaga.vaga + ' - ' + vaga.nome + ' (' + vaga.tamanhoCamisa + ')';

        if (index !== this.inscricoesExtras.length - 1) {
          resultado += ", ";
        }
      });

      return resultado;
    },

    async atualizaInscricao(callback = null) {
      this.inscricao.id = this.idInscricao;

      try {
        await axios.patch(`${baseApiUrl}Inscricoes`, this.inscricao);
        if (callback) {
          callback();
        }
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao atualizar cadastro, tente novamente", "DESCULPE");
      }
    },

    async enviaEmail() {
      try {
        await axios
          .post(`${baseApiUrl}Inscricoes/EnviaEmailInscrito`, {
            inscricaoId: this.idInscricao,
          })
          .then((res) => {
            if (res.data) {
              this.codigoAcesso = res.data.codigoAcesso;
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao enviar e-mail, tente novamente",
          "DESCULPE"
        );
      }
    },

    async realizarConsulta() {
      if (this.cpf == "") {
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha todos os campos corretamente para realizar a consulta!",
          "ATENÇÃO"
        );
      } else {
        this.isLoading = true;
        var cpfSemMascara = this.cpf.replaceAll(".", "").replaceAll("-", "");
        await axios
          .get(
            `${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"or":[{"cpf":"${this.cpf}"}, {"cpf":"${cpfSemMascara}"}]}]}}`
          )
          .then((res) => {
            if (res.data != "") {
              if (res.data[0].statusPagamento == "PENDENTE") {
                this.msgResultado = "Inscrição localizada";
                this.cultoSelecionado = this.eventos[0].nome;
                this.isLoading = false;
                this.inscricao.nome = res.data[0].nome;
                this.inscricao.cpf = res.data[0].cpf;
                this.inscricao.email = res.data[0].email;
                this.inscricao.ddd = res.data[0].ddd;
                this.inscricao.telefone = res.data[0].telefone;
                this.inscricao.sexo = res.data[0].sexo;
                this.inscricao.participantes = res.data[0].participantes;
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Volte para a tela inicial e clique em 'Faça sua inscrição agora'.",
                  "ATENÇÃO"
                );
              } else {
                if (res.data[0].statusPagamento == "PAGO") {
                  this.cultoSelecionado = this.eventos[0].nome;
                  this.inscricao.nome = res.data[0].nome;
                  this.inscricao.cod_incricao = res.data[0].cod_incricao;
                  this.inscricao.email = res.data[0].email;
                  this.inscricao.participantes = res.data[0].participantes;
                  this.dialogoIngressoIndividual = true;
                  this.isLoading = false;
                }
              }
            } else {
              this.isLoading = false;
              vm2 = this;
              vm2.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Não foi localizada inscrição para os dados informados!",
                "ATENÇÃO"
              );
            }
          });
      }
    },

    async consultaInscricaoPendente(cpf, indice) {
      this.isLoading = true;

      await axios
        .get(
          baseApiUrl +
          'inscricoes?filter={"where":{"and":[{"eventoId":"' +
          this.eventoId +
          '"},{"cpf":"' +
          cpf +
          '"}]},"include":"evento"}'
        )
        .then((response) => {
          if (response.data) {
            if (response.data[0].statusPagamento == "PENDENTE") {
              this.inscricaoLocalizada = true;
              this.msgResultado = "Inscrição localizada";
              this.cultoSelecionado = this.eventos[0].nome;
              this.isLoading = false;
              this.inscricao[indice].cod_incricao =
                response.data[0].cod_incricao;
              this.inscricao[indice].nome = response.data[0].nome;
              this.inscricao[indice].cpf = response.data[0].cpf;
              this.inscricao[indice].email = response.data[0].email;
              this.inscricao[indice].sexo = response.data[0].sexo;
              this.inscricao[indice].telefone = response.data[0].telefone;
              this.inscricao[indice].eventoId = response.data[0].eventoId;
              this.inscricao[indice].codigoTransacao =
                response.data[0].codigoTransacao;
              this.inscricao[indice].estado = response.data[0].estado;
              this.inscricao[indice].cidade = response.data[0].cidade;
              this.inscricao[indice].id = response.data[0].id;
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Para prosseguir, escolha uma forma de pagamento no final do formulário.",
                "ATENÇÃO"
              );
            } else if (response.data[0].statusPagamento == "PAGO") {
              this.inscricao.cod_incricao = response.data[0].cod_incricao;
              this.cultoSelecionado = response.data[0].evento.nome;
              this.inscricao.participantes = response.data[0].participantes;
              this.inscricao.nome = response.data[0].nome;
              this.codigoAcesso = response.data[0].codigoAcesso;
              this.inscricao.email = response.data[0].email;
              this.dialogoIngressoIndividual = true;
              this.isLoading = false;
            }
          } else {
            this.isLoading = false;
            this.consultaDadosCpf(cpf);
          }
        });
    },

    async consultaDadosCpf(cpf) {
      await axios
        .get(baseApiUrl + 'inscricoes?filter={"where":{"cpf":"' + cpf + '"}}')
        .then((response) => {
          if (response.data) {
            this.inscricao.nome = response.data[0].nome.trim();
            this.inscricao.dataNascimento = response.data[0].dataNascimento;
            this.inscricao.telefone = response.data[0].telefone;
          }
        });
    },

    async verificaCapacidade() {
      this.isLoading = true;
      let vm = this;

      this.capacidadeEvento = this.eventoSelecionado.vagas;
      this.qtdInscritos =
        this.eventoSelecionado.quantidadeInscricoes +
        this.eventoSelecionado.reserva;

      if (
        this.qtdInscritos + this.qtdCompra > this.capacidadeEvento &&
        this.capacidadeEvento - this.qtdInscritos > 0
      ) {
        this.isLoading = false;
        this.qtdCompra = 1;
        vm.$refs.chamaSnackbar.snack(
          "#0288D1",
          "Desculpe-nos, restam apenas " +
          (this.capacidadeEvento - this.qtdInscritos) +
          " vaga(s) disponível!",
          "INFORMAÇÃO"
        );
        this.verificaCapacidade();
      } else if (
        this.qtdInscritos + this.qtdCompra > this.capacidadeEvento &&
        this.capacidadeEvento - this.qtdInscritos == 0
      ) {
        this.isLoading = false;
        this.qtdCompra = 0;
        vm.$refs.chamaSnackbar.snack(
          "#0288D1",
          "Desculpe-nos, todas as vagas foram esgotadas!",
          "INFORMAÇÃO"
        );
        this.verificaCapacidade();
      } else {
        this.isLoading = false;
        if (this.qtdCompra > this.inscricao.length) {
          let novasInscricoes = [];

          for (let i = 0; i < this.qtdCompra - this.inscricao.length; i++) {
            novasInscricoes.push({
              cod_incricao: "",
              nome: "",
              cpf: "",
              email: "",
              sexo: "",
              telefone: "",
              eventoId: "",
              lote: "",
              tipo: "VIRTUAL",
              estado: "",
              cidade: "",
              tipoDocumento: this.eventoSelecionado.tipoDocumento == "AMBOS" ? this.eventoSelecionado.documentoPadrao : this.eventoSelecionado.tipoDocumento,
              valorPago: "",
              qtdSenhasExtra: 1,
              tamanhoCamisa: "",
            });
          }

          let novaLista = [...this.inscricao, ...novasInscricoes];
          this.inscricao = novaLista;
        } else {
          this.inscricao = this.removerElementos(
            this.inscricao,
            this.inscricao.length - this.qtdCompra
          );
        }
      }
    },

    removerElementos(lista, quantidade) {
      if (lista.length >= quantidade) {
        lista.splice(-quantidade, quantidade);

        return lista;
      }
    },

    async verificaVagas() {
      var vm = this;
      await axios
        .post(`${baseApiUrl}eventos/vagas`, { eventoId: this.eventoId })
        .then((response) => {
          if (response.data) {
            if (this.caravana) {
              if (response.data.vagasRestantes < 2) {
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Desculpe-nos, todas as vagas foram esgotadas!",
                  "INFORMAÇÃO"
                );
                return false;
              } else if (
                response.data.vagasRestantes < this.inscricao.participantes
              ) {
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Desculpe-nos, restam apenas " +
                  response.data.vagasRestantes +
                  " vaga(s) disponível(is)!",
                  "INFORMAÇÃO"
                );
                return false;
              }
            } else {
              if (response.data.vagasRestantes == 0) {
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Desculpe-nos, todas as vagas foram esgotadas!",
                  "INFORMAÇÃO"
                );
                return false;
              }
            }
            return true;
          }
        });
    },


    async pagamentoCartao() {
      let vm = this;

      if (
        this.pagamento.nomeTitular != "" &&
        this.pagamento.cartaoNumero != "" &&
        this.pagamento.cpfTitular != "" &&
        this.pagamento.cvv != "" &&
        this.pagamento.mesVencimento != "" &&
        this.pagamento.anoVencimento != "" &&
        this.pagamento.bandeira != "" &&
        this.pagamento.cep != "" &&
        this.pagamento.numero != "" &&
        this.pagamento.email != "" &&
        this.pagamento.valor != 0
      ) {
        this.isLoading = true;

        await this.realizarInscricao(null, "CARTAO", this.textoParcela);
        await this.criarClienteAsaas();
        if (this.idInscricao.length > 0) {
          try {
            let codInscricaoGeral;

            for (let i = 0; i < this.inscricao.length; i++) {
              if (i == 0) {
                codInscricaoGeral = this.inscricao[i].cod_incricao;
              } else {
                codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
              }
            }
            this.cobrancaAsaasCartao.customer = this.idClienteAsaas;
            this.cobrancaAsaasCartao.billingType = "CREDIT_CARD";
            this.cobrancaAsaasCartao.value = parseFloat(this.pagamento.valor);
            this.cobrancaAsaasCartao.installmentValue = parseFloat(
              parseFloat(this.pagamento.valor) /
              this.cobrancaAsaasCartao.installmentCount
            );
            this.cobrancaAsaasCartao.dueDate = moment().format("YYYY-MM-DD");
            this.cobrancaAsaasCartao.description =
              "Ref. ao evento " +
              this.eventoSelecionado.nome +
              " para as insc. de nº " +
              codInscricaoGeral;
            this.cobrancaAsaasCartao.inscricaoId = this.idInscricao;
            this.cobrancaAsaasCartao.empresaId = this.empresa.id;
            axios.get("https://api.ipify.org/?format=json").then((res) => {
              if (res.data) {
                try {
                  this.cobrancaAsaasCartao.remoteIp = res.data.ip;
                } catch (error) {
                  this.cobrancaAsaasCartao.remoteIp = "127.0.0.1";
                }
              } else {
                this.cobrancaAsaasCartao.remoteIp = "127.0.0.1";
              }
            });
            // inserindo dados do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCard.holderName =
              this.pagamento.nomeTitular;
            this.cobrancaAsaasCartao.creditCard.number =
              this.pagamento.cartaoNumero;
            this.cobrancaAsaasCartao.creditCard.expiryMonth =
              this.pagamento.mesVencimento;
            this.cobrancaAsaasCartao.creditCard.expiryYear =
              this.pagamento.anoVencimento;
            this.cobrancaAsaasCartao.creditCard.ccv = this.pagamento.cvv;
            // inserindo dados do responśavel do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCardHolderInfo.name =
              this.pagamento.nomeTitular;
            this.cobrancaAsaasCartao.creditCardHolderInfo.email =
              this.pagamento.email.trim().toLowerCase();
            this.cobrancaAsaasCartao.creditCardHolderInfo.cpfCnpj =
              this.pagamento.cpfTitular;
            this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode =
              this.pagamento.cep;
            this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber =
              this.pagamento.numero;
            this.cobrancaAsaasCartao.creditCardHolderInfo.phone =
              this.inscricao[0].telefone.replace(/[^\d]+/g, "");
            this.cobrancaAsaasCartao.creditCardHolderInfo.mobilePhone =
              this.inscricao[0].telefone.replace(/[^\d]+/g, "");

            await axios
              .post(
                baseApiUrl + "Pagamentos/AsaasCobranca",
                this.cobrancaAsaasCartao
              )
              .then((response) => {
                if (response.data.cobranca.status == "CONFIRMED") {
                  this.finalizaInscricao();
                  if (this.cupomAplicado) this.atualizaCupomsUtilizados();
                }
              });
          } catch (error) {
            this.idInscricao = [];
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Transação não autorizada. Verifique os dados informados e tente novamente ou utilize um outro cartão.",
              "DESCULPE"
            );
          }
        } else {
          this.idInscricao = [];
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Falha ao realizar inscrição, tente novamente!",
            "DESCULPE"
          );
        }
      } else {
        this.$validator.validateAll();
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha todos os campos corretamente para continuar!",
          "ATENÇÃO"
        );
      }
    },

    async criarClienteAsaas() {
      this.clienteAsaas.name = this.pagePagamento
        ? this.pagamento.nomeTitular
        : this.inscricao[0].nome;
      this.clienteAsaas.cpfCnpj = this.pagePagamento
        ? this.pagamento.cpfTitular
        : this.inscricao[0].cpf;
      this.clienteAsaas.email = this.pagamento.email;
      this.clienteAsaas.mobilePhone = this.inscricao[0].telefone.replace(
        /[^\d]+/g,
        ""
      );
      this.clienteAsaas.postalCode = this.pagamento.cep;
      this.clienteAsaas.addressNumber = this.pagamento.numero;
      this.clienteAsaas.phone = this.inscricao[0].telefone.replace(
        /[^\d]+/g,
        ""
      )
      this.clienteAsaas.empresaId = this.empresa.id;

      try {
        await axios
          .post(baseApiUrl + "Pagamentos/criarCliente", this.clienteAsaas)
          .then((response) => {
            if (response.data) {
              this.idClienteAsaas = response.data.id;
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagamentoBoleto() {
      this.isLoading = true;

      await this.realizarInscricao(null, "BOLETO", "A VISTA");
      await this.criarClienteAsaas();
      if (this.idInscricao) {
        let codInscricaoGeral;

        for (let i = 0; i < this.inscricao.length; i++) {
          if (i == 0) {
            codInscricaoGeral = this.inscricao[i].cod_incricao;
          } else {
            codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
          }
        }

        try {
          this.cobrancaAsaas.customer = this.idClienteAsaas;
          this.cobrancaAsaas.value = (
            parseFloat(this.valorTotalCompra.replace(",", ".")) +
            parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(",", "."))
          ).toFixed(2);
          this.cobrancaAsaas.dueDate = moment().format("YYYY-MM-DD");
          this.cobrancaAsaas.billingType = "BOLETO";
          this.cobrancaAsaas.description =
            "Ref. ao evento " +
            this.cultoSelecionado +
            " para as insc. de nº " +
            codInscricaoGeral;
          this.cobrancaAsaas.inscricaoId = this.idInscricao;
          this.cobrancaAsaas.empresaId = this.empresa.id;
          await axios
            .post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaas)
            .then((res) => {
              if (res.data) {
                this.linkBoleto = res.data.cobranca.bankSlipUrl;
                this.finalizaInscricao();
                if (this.cupomAplicado) this.atualizaCupomsUtilizados();
              }
            });
        } catch (error) {
          this.isLoading = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Problema encontrado ao gerar o boleto. Tente novamente mais tarde.",
            "DESCULPE"
          );
        }
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    abreBoleto() {
      window.open(this.linkBoleto);
    },

    async pagarPixAsaas() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      await this.criarClienteAsaas();
      if (this.idInscricao.length > 0) {
        try {
          let codInscricaoGeral;

          for (let i = 0; i < this.inscricao.length; i++) {
            if (i == 0) {
              codInscricaoGeral = this.inscricao[i].cod_incricao;
            } else {
              codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
            }
          }

          this.cobrancaAsaas.customer = this.idClienteAsaas;
          let valorTotalPix = typeof this.valorTotalCompra === 'string' 
            ? parseFloat(this.valorTotalCompra.replace(",", ".")) 
            : parseFloat(this.valorTotalCompra);
          this.cobrancaAsaas.value = valorTotalPix.toFixed(2);
          this.cobrancaAsaas.dueDate = moment().format("YYYY-MM-DD");
          this.cobrancaAsaas.billingType = "PIX";
          this.cobrancaAsaas.description =
            "Ref. ao evento " +
            this.eventoSelecionado.nome +
            " para as insc. de nº " +
            codInscricaoGeral;
          this.cobrancaAsaas.inscricaoId = this.idInscricao;
          this.cobrancaAsaas.empresaId = this.empresa.id;
          await axios
            .post(baseApiUrl + "Pagamentos/AsaasCobranca", this.cobrancaAsaas)
            .then((response) => {
              if (response.data) {
                this.inscricao.codigoTransacao =
                  response.data.cobranca.invoiceUrl;
                this.qrCode64 =
                  "data:image/jpeg;base64," + response.data.qrCode.encodedImage;
                this.chaveCopiaeCola = response.data.qrCode.payload;
                this.msgResultado = "Pré-inscrição realizada com sucesso";
                this.pagamentoPix = true;
                this.isLoading = false;
                this.inscricao.id = this.idInscricao;
                this.consultaPagamentoPix(response.data.id);
                if (this.cupomAplicado) this.atualizaCupomsUtilizados();
              }
            });
        } catch (error) {
          this.idInscricao = [];
          this.isLoading = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Falha ao gerar pagamento. Tente novamente mais tarde.",
            "DESCULPE"
          );
        }
      } else {
        this.idInscricao = [];
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    consultaPagamentoPix() {
      try {
        this.verificaPagamento = setInterval(
          function () {
            axios
              .post(baseApiUrl + "Pagamentos/AsaasCobrancaConsulta", {
                inscricaoId: this.idInscricao[0],
                empresaId: this.empresa.id,
              })
              .then((res3) => {
                if (res3.data.status == "RECEIVED") {
                  this.finalizaInscricao();
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this),
          5000
        );
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Não foi possível verificar o pagamento, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagarPixTaPago() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      if (this.idInscricao.length > 0) {
        let codInscricaoGeral;

        for (let i = 0; i < this.inscricao.length; i++) {
          if (i == 0) {
            codInscricaoGeral = this.inscricao[i].cod_incricao;
          } else {
            codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
          }
        }

        let dadosCobranca = {
          empresaId: this.empresa.id,
          inscricaoId: this.idInscricao,
          valor: "",
          descricao: "Ref. ao evento " + this.eventoSelecionado.nome + " para a insc. de nº " + codInscricaoGeral,
        };

        let valorTotalPix = typeof this.valorTotalCompra === 'string' 
          ? parseFloat(this.valorTotalCompra.replace(",", ".")) 
          : parseFloat(this.valorTotalCompra);
        dadosCobranca.valor = valorTotalPix.toFixed(2);

        await axios.post(baseApiUrl + "Pagamentos/taPagoCobranca", dadosCobranca)
          .then((response) => {
            if (response.data) {
              this.qrCode64 = "data:" + response.data.instantPayment.generateImage.mimeType + ";base64," + response.data.instantPayment.generateImage.imageContent;
              this.chaveCopiaeCola = response.data.instantPayment.textContent;
              this.msgResultado = "Pré-inscrição realizada com sucesso";
              this.pagamentoPix = true;
              this.isLoading = false;
              this.consultaPagamentoPixTaPago();
              if (this.cupomAplicado) this.atualizaCupomsUtilizados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao gerar pagamento. Tente novamente mais tarde.", "DESCULPE");
          });
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE");
      }
    },

    async consultaPagamentoPixTaPago() {
      try {
        this.verificaPagamento = setInterval(
          async function () {
            await axios.post(baseApiUrl + "Pagamentos/taPagoCobrancaConsulta", { inscricaoId: this.idInscricao[0], empresaId: this.empresa.id })
              .then((res3) => {
                if (res3.data.status == "APPROVED") {
                  this.isLoading = true;
                  this.finalizaInscricao();
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this), 5000
        );
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
      }
    },

    async pagarPixSicoob() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      if (this.idInscricao.length > 0) {
        let dadosCobranca = {
          empresaId: this.empresa.id,
          inscricaoId: this.idInscricao,
          calendario: {
            expiracao: 3600
          },
          devedor: {
            cpf: this.inscricao[0].cpf,
            nome: this.inscricao[0].nome,
          },
          valor: {
            original: ""
          },
          chave: "ecommerce@intelite.com.br",
          solicitacaoPagador: "INTELITE TECNOLOGIA",
        };

        let valorTotalPix = typeof this.valorTotalCompra === 'string' 
          ? parseFloat(this.valorTotalCompra.replace(",", ".")) 
          : parseFloat(this.valorTotalCompra);
        dadosCobranca.valor.original = valorTotalPix.toFixed(2);

        await axios.post(baseApiUrl + "Pagamentos/sicoobCobranca", dadosCobranca)
          .then((response) => {
            if (response.data) {
              this.qrCode64 = response.data.brcode
              this.chaveCopiaeCola = response.data.brcode
              this.msgResultado = "Pré-inscrição realizada com sucesso";
              this.pagamentoPix = true;
              this.isLoading = false;
              this.consultaPagamentoPixSicoob();
              if (this.cupomAplicado) this.atualizaCupomsUtilizados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao gerar pagamento. Tente novamente mais tarde.", "DESCULPE");
          });
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE"
        );
      }
    },

    async consultaPagamentoPixSicoob() {
      try {
        this.verificaPagamento = setInterval(
          async function () {
            await axios.post(baseApiUrl + "Pagamentos/sicoobCobrancaConsulta", { "inscricaoId": this.idInscricao[0] })
              .then((res3) => {
                if (res3.data.status == "APPROVED") {
                  this.isLoading = true;
                  this.finalizaInscricao();
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this), 5000);
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
      }
    },

    async imprimirBoleto() {
      //Baixando Boleto PDF
      try {
        let res = await axios.get(
          `https://p4x.srv.br/api/v1.0/boletos/${this.inscricao.boletoId}/imprimir`,
          {
            responseType: "arraybuffer",
            headers: {
              Authorization: "Bearer " + this.token, //the token is a variable which holds the token
              "Content-type": "application/pdf",
            },
          }
        );
        if (res.data) {
          //Create a Blob from the PDF Stream
          const file = new Blob([res.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileURL;
          link.setAttribute("download", "boleto.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
          //Open the URL on new Window
          window.open(fileURL);
          //exibe mensagem de conclusao
          this.isLoading = false;
          this.dialogLoading = true;
        }
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao imprimir boleto. Tente novamente ou entre em contato com a Intelite Tecnologia!", "ERRO");
      }
    },

    finalizaInscricao() {
      this.isLoading = false;
      if (this.inscricao.formOfPayment == "CARTAO") {
        this.msgResultado = "Compra realizada com sucesso!";
        this.dialogoListaIngresso = true;
      } else if (this.inscricao.formOfPayment == "BOLETO") {
        this.msgResultado = "Pré inscrição realizada com sucesso!";
        this.confirmacaoBoleto = true;
      } else if (this.inscricao.formOfPayment == "EM MAOS") {
        this.msgResultado = "Pré inscrição realizada com sucesso!";
        this.confirmacaoEmMaos = true;
      } else {
        this.pagamentoPix = false;
        this.msgResultado = "Compra realizada com sucesso!";
        this.dialogoListaIngresso = true;
      }
    },

    //Função para criptografia
    encrypt(text) {
      let crypto = require("crypto");
      let password = "pxuelh2so839ljis";
      let iv = "pxuelh2so839ljis";
      let cipher = crypto.createCipheriv("aes-128-cbc", password, iv);
      let encryptedData = cipher.update(text, "utf8", "Base64") + cipher.final("Base64");

      return encryptedData;
    },

    closeDialog() {
      this.pagamentoPix = false;

      if (!this.consultaCPF) {
        this.reloadPage();
      }

      this.$validator.reset();

      if (this.consultaCPF) {
        this.consultaCPF = false;
        this.inscricao = Object.assign({}, this.inscricaoDefault);
      }
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.nome;
      const dataB = b.nome;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    calculateAge(dobString) {
      var dob = new Date(dobString);
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
      var age = currentYear - dob.getFullYear();

      if (birthdayThisYear > currentDate) {
        age--;
      }

      return age;
    },

    formatDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    async pegaParametrosUrl() {
      var params = window.location.search.substring(1).split("&");
      if (params[0] != "") {
        this.isLoading = true;
        let paramArray = {}; // Criar objeto que vai conter os parametros

        for (var i = 0; i < params.length; i++) {
          // Passar por todos os parametros
          var param = params[i].split("="); // Dividir os parametros chave e valor
          paramArray[param[0]] = param[1]; // Adicionar ao objeto criado antes
        }

        if (paramArray["cod"]) {
          await axios.post(baseApiUrl + "inscricoes/consultarInscricaoCodigo", { cod_incricao: paramArray["cod"] })
            .then(async (response) => {
              if (response.data) {
                if (response.data.statusPagamento == "PAGO") {
                  this.inscricaoLocalizada = Object.assign({}, response.data);
                  this.dialogoIngressoIndividual = true;
                } else {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Pagamento da inscrição não foi efetuado.", "ATENÇÃO");
                }
              }
            });
        }

        if (paramArray["d"]) {
          this.consultaDivulgador(paramArray["d"]);
        }

        if (paramArray["e"]) {
          await axios.post(baseApiUrl + "eventos/porId", { eventoId: paramArray["e"] })
            .then((response) => {
              if (response.data) {
                if (moment(this.formatDateHora(response.data.fim), "DD/MM/YYYY HH:mm:ss", true).format() >= moment().format()) {
                  this.bloqueiaVoltar = true;
                  this.realizarInscricaoGrupo(response.data);
                }
              }
            });
        }
      }
      this.isLoading = false;
    },

    async salvaHoraVisualizacao(id) {
      await axios.patch(baseApiUrl + "inscricoes/" + id, {
        visualizado: true,
        ultimaVisualizacao: moment().toISOString(),
      });
    },

    async consultarInscricao(cpf, cod) {
      var vm = this;
      if (cpf) {
        this.isLoading = true;
        let envio = {
          eventoId: this.eventoId,
          cpf: cpf,
          enviaToken: true,
          canalNotificacao: "ZAP",
          cod_incricao: cod,
        };

        try {
          await axios.post(`${baseApiUrl}inscricoes/consultarInscricao`, envio)
            .then((response) => {
              if (response.data.length > 0) {
                this.idInscricao = response.data;
                this.dialogoToken = true;
                this.consultaCPF = true;
                this.isLoading = false;
              }
            });
        } catch (error) {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao consultar inscrição, tente novamente!", "DESCULPE");
        }
      } else {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Informe o CPF para consultar", "ATENÇÃO");
      }
    },

    async confirmaToken() {
      var vm = this;

      if (this.token) {
        this.isLoading = true;
        let confirmacao = {
          token: this.token,
          inscricaoId: this.idInscricao,
        };
        await axios.post(`${baseApiUrl}inscricoes/confirmToken`, confirmacao)
          .then((response) => {
            if (response.data) {
              if (response.data.statusPagamento == "PAGO") {
                this.consultaCPF = true;
                this.cultoSelecionado = this.eventos[0].nome;
                this.inscricao.nome = response.data.nome;
                this.inscricao.cod_incricao = response.data.cod_incricao;
                this.inscricao.email = response.data.email;
                this.inscricao.participantes = response.data.participantes;
                this.dialogoToken = false;
                this.token = "";
                this.dialogoIngressoIndividual = true;
                this.isLoading = false;
                this.idInscricao = "";
              } else if (response.data.statusPagamento == "PENDENTE") {
                this.inscricaoLocalizada = true;
                this.consultaInscricao(this.idInscricao);
                if (response.data.participantes > 1) {
                  this.dialogoToken = false;
                  this.isLoading = false;
                  this.pageConsulta = false;
                  this.realizarInscricaoGrupo();
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.", "ATENÇÃO");
                } else {
                  this.dialogoToken = false;
                  this.isLoading = false;
                  this.pageConsulta = false;
                  this.realizarInscricaoAgora();
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.", "ATENÇÃO");
                }
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              } else if (response.data.statusPagamento == "CANCELADO") {
                this.dialogoToken = false;
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação cancelada.", "ATENÇÃO");
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              } else if (response.data.statusPagamento == "ESTORNADO") {
                this.dialogoToken = false;
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação estornada.", "ATENÇÃO");
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              }
            } else {
              this.isLoading = false;
              vm.$refs.chamaSnackbar.snack("#F9A825", "Token inválido, tente novamente", "ATENÇÃO");
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao confirmar token, tente novamente", "DESCULPE");
          });
      } else {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Informe o token enviado para continuar", "ATENÇÃO");
      }
    },

    async consultaInscricao(id) {
      await axios.get(baseApiUrl + "inscricoes/" + id).then((response) => {
        if (response.data) {
          this.inscricao.nome = response.data.nome;
          this.inscricao.cpf = response.data.cpf;
          this.inscricao.dataNascimento = response.data.dataNascimento;
          this.inscricao.telefone = response.data.telefone;
          this.inscricao.possuiNecessidade = response.data.possuiNecessidade;
          this.inscricao.necessidadeEspecial = response.data.necessidadeEspecial;
        }
      });
    },

    async consultaDivulgador(id) {
      await axios.get(baseApiUrl + "Divulgadores/" + id).then((response) => {
        if (response.data) {
          if (response.data.ativo) {
            this.indicacao = true;
            this.divulgador = response.data;
            axios.patch(baseApiUrl + 'Divulgadores/' + id, { "qtdClicks": response.data.qtdClicks ? response.data.qtdClicks + 1 : 1 })
          }
        }
      });
    },

    retornaData(tipo) {
      return moment().format(tipo);
    },

    retornaPaginaPrincipal() {
      if (this.eventoSelecionado.matrizColuna && this.eventoSelecionado.matrizLinha) {
        this.paginaInscricaoVagas = false;
      } else {
        this.paginaInscricaoGrupo = false;
      }

      this.pagePrincipal = true;

      this.eventoSelecionado = [];
      this.inscricao = this.inscricaoDefault;
      this.exibeMapa = false
    },

    async buscaUfs() {
      await axios.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome")
        .then((response) => {
          if (response.data) {
            this.estados = response.data;
          }
        });
    },

    async buscaMunicipios() {
      await axios.get("https://servicodados.ibge.gov.br/api/v1/localidades/municipios?view=nivelado")
        .then((response) => {
          if (response.data) {
            this.municipios = response.data;
          }
        });
    },

    getItemText(item) {
      return item.nome;
    },

    calculaValorTotal(setor, indice) {
      let vm = this;

      // localiza o setor escolhido pelo preço e o salva na inscrição
      for (let i = 0; i < this.eventoSelecionado.setores.length; i++) {
        if (this.eventoSelecionado.setores[i].nome == setor) {
          if (this.verificaVagaDisponivel(this.eventoSelecionado.setores[i].nome) > 0) {
            this.inscricao[indice].valorPago = this.eventoSelecionado.setores[i].valor;
            this.inscricao[indice].corSetor = this.eventoSelecionado.setores[i].cor;
          } else {
            this.inscricao[indice].valorPago = "";
            this.inscricao[indice].setor = "";
            this.inscricao[indice].corSetor = "";
            vm.$refs.chamaSnackbar.snack("#F9A825", "Quantidade máxima atingida para o setor", "ATENÇÃO");
          }
          break;
        }
      }

      if (this.inscricao[indice].tipoDocumento == "CNPJ" && this.eventoSelecionado.desconto) {
        this.inscricao[indice].valorPago = parseFloat(this.inscricao[indice].valorPago.replace(",", ".") - this.eventoSelecionado.desconto.replace(",", ".")).toFixed(2).replace(".", ",");
      }

      this.valorTotalCompra = 0;

      this.inscricao.forEach((inscricao) => {
        if (inscricao.valorPago) {
          this.valorTotalCompra += parseFloat(inscricao.valorPago.replace(",", "."));
        }
      });

      if (this.empresa.limiteInscricao == "SETOR") {
        this.pegaVagasDisponiveis();
      }
    },

    async pegaVagasDisponiveis() {
      await axios.post(baseApiUrl + "Empresas/vagasDisponiveis", { empresaId: this.empresa.id })
        .then((response) => {
          if (response.data) {
            this.vagasDisponiveis = response.data;
          }

          if (this.inscricao.length > 0) {
            for (let i = 0; i < this.inscricao.length; i++) {
              if (this.inscricao[i].setor) {
                this.vagasDisponiveis[this.inscricao[i].setor] =
                  this.vagasDisponiveis[this.inscricao[i].setor] - 1;
              }
            }
          }
        });
    },

    verificaVagaDisponivel(setor) {
      return this.vagasDisponiveis[setor] - 1;
    },

    limpaSetor(indice) {
      if (this.inscricao[indice].valorPago) {
        this.valorTotalCompra -= parseFloat(
          this.inscricao[indice].valorPago.replace(",", ".")
        );
      }

      this.inscricao[indice].valorPago = "";
      this.inscricao[indice].setor = "";
      this.inscricao[indice].corSetor = "";
    },

    preencherInformacoes(indice) {
      let answer = confirm('Deseja preencher os dados desta inscrição com os dados da primeira inscrição?')

      if (answer) {
        this.inscricao[indice].cpf = this.inscricao[0].cpf
        this.inscricao[indice].nome = this.inscricao[0].nome + ' ' + (indice + 1)
        this.inscricao[indice].dataNascimento = this.inscricao[0].dataNascimento
        this.inscricao[indice].telefone = this.inscricao[0].telefone
        this.inscricao[indice].possuiNecessidade = this.inscricao[0].possuiNecessidade
      }
    },

    async getVagas() {
      this.isLoading = true;
      try {
        let vagasSelecionadas = []
        const response = await axios.post(baseApiUrl + 'Vagas/busca', { "eventoId": this.eventoSelecionado.id });

        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].status == 'SELECIONADO' && response.data[i].cpf && response.data[i].cpf !== this.inscricao[0].cpf) {
            response.data[i].bloqueado = true
          } else if (response.data[i].status == 'SELECIONADO' && response.data[i].cpf && response.data[i].cpf === this.inscricao[0].cpf) {
            vagasSelecionadas.push({
              "vaga": response.data[i].vaga,
              "setor": response.data[i].setor,
              "tipo": response.data[i].tipo,
            })
          }
        }

        if (vagasSelecionadas.length > 0) {
          this.inscricao[0].vagas = vagasSelecionadas
          this.qtdVagas()
        }

        // Normaliza os dados de `localizacao` para números
        this.clickedCells = response.data.map((vaga) => ({
          ...vaga,
          localizacao: parseInt(vaga.localizacao),
        }));

        // console.log("Dados das vagas carregados e normalizados:", this.clickedCells);
        this.updateMatrixCells();
        this.isLoading = false;
      } catch (error) {
        // console.error("Erro ao carregar vagas:", error);
        this.isLoading = false;
      }
    },

    async cellClicked(rowIndex, colIndex) {
      const cell = this.matrix[rowIndex][colIndex];

      if (cell.active) {
        this.isLoading = true;
        this.pegaCamisas(this.eventoSelecionado.id)

        await axios.post(baseApiUrl + 'Vagas/vaga', { "vagaId": cell.id })
          .then(async response => {
            if (response.data) {
              if (!this.inscricao[0].vagas) {
                this.inscricao[0].vagas = [];
              }

              if (response.data.status == 'LIVRE') {
                // Limpa qualquer vaga previamente selecionada antes de adicionar a nova
                /* if (this.inscricao[0].vagas.length > 0) {
                  this.isLoading = false;
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Você já selecionou uma cadeira, não é possível selecionar outra!",
                    "ATENÇÃO"
                  );
                  const vagaAnterior = this.inscricao[0].vagas[0];
                  await this.setaStatus({ "vagaId": vagaAnterior.id, "status": "LIVRE", "cpf": this.inscricao[0].cpf });
                  this.inscricao[0].vagas = [];
                } */
                this.matrix[rowIndex][colIndex] = await this.setaStatus({ "vagaId": cell.id, "status": "SELECIONADO", "cpf": this.inscricao[0].cpf });
                this.inscricao[0].vagas.push({
                  "vaga": cell.vaga,
                  "setor": cell.setor,
                });

                if (this.inscricao[0].vagas.length >= 2) {
                  this.inscricoesExtras.push({
                    "vaga": cell.vaga,
                    "nome": "",
                    "tamanhoCamisa": "",
                  })
                }
              } else if (response.data.status == 'SELECIONADO') {
                if (response.data.cpf == this.inscricao[0].cpf) {
                  this.matrix[rowIndex][colIndex] = await this.setaStatus({ "vagaId": cell.id, "status": "LIVRE", "cpf": this.inscricao[0].cpf });
                  this.inscricao[0].vagas = this.inscricao[0].vagas.filter(function (item) {
                    return item.vaga !== cell.vaga;
                  });

                  this.inscricoesExtras = this.inscricoesExtras.filter(function (item) {
                    return item.vaga !== cell.vaga;
                  });
                }
              } else if (response.data.status == 'OCUPADO') {
                this.matrix[rowIndex][colIndex] = response.data;
              }
            }
          });

        this.x++;
        this.isLoading = false;
        this.qtdVagas();
      }
    },

    adjustBackgroundSize() {
      const matrix = this.$refs.matrixTable;
      const container = this.$refs.matrixContainer;
      if (matrix && container) {
        // Ajusta o tamanho da imagem para cobrir as dimensões da tabela
        this.backgroundStyle.backgroundSize = `${matrix.offsetWidth}px ${matrix.offsetHeight}px`;

        // Certifique-se que a posição de fundo é centralizada
        this.backgroundStyle.backgroundPosition = "center center";

        // Aplica os estilos ao container diretamente para garantir que sejam aplicados
        container.style.backgroundImage = this.eventoSelecionado.backgroundImage;
        container.style.backgroundSize = this.backgroundStyle.backgroundSize;
        container.style.backgroundPosition = this.backgroundStyle.backgroundPosition;
        container.style.backgroundRepeat = "no-repeat";
        container.style.width = `${matrix.offsetWidth}px`;
        container.style.height = `${matrix.offsetHeight}px`;
      }
    },

    async setaStatus(dados) {
      let response = await axios.post(baseApiUrl + 'Vagas/setaStatus', dados)

      if (response.data) {
        return response.data
      }
    },

    formatarLista(lista) {
      if (lista) {
        let resultado = "";

        lista.forEach((aluno, index) => {
          if (!resultado.includes(aluno.nome + " (" + aluno.turma + ')')) {
            resultado += aluno.nome + " (" + aluno.turma + ')';

            if (index !== lista.length - 1) {
              resultado += " | ";
            }
          }
        });

        return resultado;
      }
    },

    qtdVagas() {
      this.vagasSelecionadas = ''

      for (let i = 0; i < this.inscricao[0].vagas.length; i++) {
        this.vagasSelecionadas += this.inscricao[0].vagas[i].vaga

        if (i !== this.inscricao[0].vagas.length - 1) {
          this.vagasSelecionadas += ", ";
        }
      }

      // Recalcula o valor total baseado nos setores das cadeiras selecionadas
      if (this.eventoSelecionado.valorPix || this.eventoSelecionado.valorCartao) {
        if (this.eventoSelecionado.valorPix) {
          this.valorTotalCompra = this.calculaValorInscricoes("valorPix");
        }
        if (this.eventoSelecionado.valorCartao) {
          this.valorTotalCompra = this.calculaValorInscricoes("valorCartao");
        }
      }
    },

    pegarAcrescimosSetores() {
      for (let i = 0; i < this.eventoSelecionado.setores.length; i++) {
        let quantidade = 0;
        
        // Se há cadeiras selecionadas (matriz), contar pelas vagas
        if (this.eventoSelecionado.matrizLinha && this.eventoSelecionado.matrizColuna && this.inscricao[0].vagas && this.inscricao[0].vagas.length > 0) {
          quantidade = this.inscricao[0].vagas.filter(vaga => vaga.setor == this.eventoSelecionado.setores[i].nome).length;
        } else {
          // Caso contrário, usar a lógica original com setor direto na inscrição
          quantidade = this.inscricao.filter(inscricao => inscricao.setor == this.eventoSelecionado.setores[i].nome).length;
        }
        
        if (quantidade > 0) {
          let keys = Object.keys(this.eventoSelecionado.setores[i]);
          keys = keys.filter(key => key.includes("acrescimoCartao"));

          for (let j = 0; j < keys.length; j++) {
            let valorAcrescimo = parseFloat(this.eventoSelecionado.setores[i][keys[j]].replace(",", ".")) * quantidade
            this.valorAcrescimo[keys[j]] = this.valorAcrescimo[keys[j]] != "0,00" ? this.valorAcrescimo[keys[j]] : "0,00";
            this.valorAcrescimo[keys[j]] = (parseFloat(this.valorAcrescimo[keys[j]].replace(",", ".")) + valorAcrescimo).toFixed(2).replace(".", ",");
          }
        }
      }
    },

    formatarSetor(lista) {
      if (lista) {
        let resultado = "";
        
        // Criar cópia da lista e inverter a ordem
        const listaInvertida = [...lista].reverse();

        listaInvertida.forEach((vaga, index) => {
          // Exibir apenas o número da vaga
          resultado += vaga.vaga;

          if (index !== listaInvertida.length - 1) {
            resultado += ", ";
          }
        });

        return resultado;
      }
      return "";
    },

    callFunctionPixPayment() {
      if (this.empresa.gatewayPagamentoPix == "TAPAGO") {
        this.pagarPixTaPago()
      }
      else if (this.empresa.gatewayPagamentoPix == "ASAAS") {
        this.pagarPixAsaas()
      }
      else if (this.empresa.gatewayPagamentoPix == "SICOOB") {
        this.pagarPixSicoob()
      }
    },

    visualizarIngressoIndividual(item) {
      this.inscricao = [item];
      
      // Preencher inscricaoLocalizada com os dados do ingresso
      this.inscricaoLocalizada = {
        cod_incricao: item.cod_incricao,
        nome: item.nome,
        email: item.email,
        sexo: item.sexo,
        telefone: item.telefone,
        eventoNome: this.eventoSelecionado.nome,
        eventoLocal: this.eventoSelecionado.local,
        eventoLocalizacao: this.eventoSelecionado.localizacao,
        eventoUsaCartaoConsumo: this.eventoSelecionado.usaCartaoConsumo,
        vagas: item.vagas,
        setor: "",
        corSetor: "",
      };
      
      this.dialogoIngressoIndividual = true;
      this.dialogoListaIngresso = false;
    },
  },
};
</script>

<style scoped>
/* LOGIN */
.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 0px;
  background: linear-gradient(to right, #424242, #616161);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253e;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 0px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.no-break {
  word-wrap: normal;
  /* Usamos 'normal' em vez de 'break-word' para impedir a quebra no meio de palavras */
  word-break: keep-all;
  /* Isso também ajuda a prevenir a quebra no meio de palavras */
  white-space: pre-line;
  /* Isto vai respeitar os espaços em branco e quebras de linha */
}

a {
  text-decoration: none;
}

.theme--light.v-data-table thead tr th {
  color: white;
}

table {
  border-collapse: collapse;
}

td {
  width: 12px;
  height: 12px;
  border: 0px solid black;
  line-height: 0.5rem;
}

tr {
  height: 4px;
}

.active {
  background-color: #4caf50;
  color: white;
}

form {
  text-align: center;
  margin-bottom: 20px;
}

input[type="number"],
input[type="text"] {
  padding: 8px;
  margin-right: 10px;
  margin-top: 10px;
}

#clickedCellsInfo {
  text-align: center;
  margin-top: 10px;
}
</style>
